/* ============================================================
   ef-orderform-doors.js v2 (2026-05-08)
   Populates card-style dropdowns from window.EF_CFG_DATA. Each option
   is rendered as a card (image + label + description + price). Click
   a card → records selection + closes the <details> + recomputes total.

   United Inches calc: Width + Height auto-snaps to a size tier from
   data.size[] (each has its own variantId surcharge for the cart).
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('efOf');
  if (!root) return;

  var BASE_PRICE = parseInt(root.dataset.basePrice || '0', 10);
  var PRODUCT_HANDLE = root.dataset.productHandle || '';
  var BASE_VARIANT_ID = root.dataset.variantId || '';
  var CFG_GROUP = root.dataset.cfgGroup || '';

  /* DOM refs */
  var widthInput = document.getElementById('efOfWidth');
  var heightInput = document.getElementById('efOfHeight');
  var unitedEl = document.getElementById('efOfUnitedInches');
  var matchEl = document.getElementById('efOfMatch');
  var matchTier = document.getElementById('efOfMatchTier');
  var matchPrice = document.getElementById('efOfMatchPrice');
  /* Live total drives the TOP headline price (#ef-price-display) so the product
     name + price aren't duplicated inside the configurator (gas-logs parity w/ doors). */
  var priceEl = document.getElementById('ef-price-display') || document.getElementById('efOfPrice');
  var baseAmt = document.getElementById('efOfBaseAmt');
  var totalLines = document.getElementById('efOfTotalLines');
  var totalAmt = document.getElementById('efOfTotalAmt');
  var atcPrice = document.getElementById('efOfAtcPrice');
  var atcBtn = document.getElementById('efOfAtc');
  var form = document.getElementById('efOfForm');
  var variantInput = document.getElementById('efOfVariantId');
  var msgEl = document.getElementById('efOfMsg');
  var fileInput = document.getElementById('efOfFile');
  var fileLabel = document.getElementById('efOfFileLabel');
  var notesEl = document.getElementById('efOfNotes');
  var details = root.querySelectorAll('.ef-of__cd');

  /* Format cents → "$1,234" or "$12.50" if non-zero cents. */
  function money(cents) {
    var n = Math.round(cents);
    var sign = n < 0 ? '-' : '';
    var abs = Math.abs(n);
    var dollars = Math.floor(abs / 100);
    var rem = abs % 100;
    var withCommas = dollars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sign + '$' + withCommas + (rem === 0 ? '' : '.' + (rem < 10 ? '0' + rem : rem));
  }
  /* CRITICAL — option surcharges in EF_CFG_DATA are stored in DOLLARS not cents
     (e.g. { price: 25 } = $25). Convert to cents before formatting via money(). */
  function moneyDollars(dollars) {
    return money(Math.round((dollars || 0) * 100));
  }

  /* State */
  var state = {
    selections: {}, /* groupKey -> {label, price, variantId, img, desc} */
    sizeSel: null,  /* { label, price, variantId } from data.size matched to W+H */
  };

  /* ── Match product → EF_CFG_DATA group ──────────────────────────
     Lifted 1:1 from ef-configurator-v2.js:121-366 — same ALIASES,
     MODEL_NAMES pass1, longest-keyword pass2. Without this, products
     like Brookfield/Stiletto/Carolina/Legend fell through to first
     available group → wrong data → broken configurator.
     Returns the matched GROUP NAME (e.g. "Fireplace Doors - Cabot")
     or null. findGroupData() wraps it to return the data block. */
  var SKIP_WORDS = ['all', 'mid', 'old', 'new', 'hand', 'arch', 'the', 'and', 'for'];
  function matchProductToGroup() {
    var data = window.EF_CFG_DATA;
    if (!data) { console.warn('[ef-orderform] EF_CFG_DATA not loaded'); return null; }
    var prodTitle = (root.dataset.productTitle || '').toLowerCase();

    var ALIASES = {
      'brookfield deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'brookfield – deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'brookfield - deluxe': 'Fireplace Doors - Brookfield Deluxe',
      'bar iron arch':    'Fireplace Doors - DS Arch',
      'bar iron - arch':  'Fireplace Doors - DS Arch',
      'forgeline arch':   'Fireplace Doors - DS Arch',
      'forged iron arch': 'Fireplace Doors - DS Arch',
      'old world arch':   'Fireplace Doors - Old World Arch',
      'old world - arch': 'Fireplace Doors - Old World Arch',
      'smithline arch':   'Fireplace Doors - Smithline Arch',
      'smithline - arch': 'Fireplace Doors - Smithline Arch',
      'industrial arch':  'Fireplace Doors - Smithline Arch',
      'industrial - arch':'Fireplace Doors - Smithline Arch',
      'metro arch':       'Fireplace Doors - Smithline Arch',
      'buckingham arch':  'Fireplace Doors - DS Arch',
      'buckingham':       'Fireplace Doors - DS Arch',
      'black rock arch':  'Fireplace Doors - DS Arch',
      'legend plain arch':'Fireplace Doors - DS Arch',
      'legend plain':     'Fireplace Doors - DS Arch',
      'forgeline': 'Fireplace Doors - Bar Iron',
      'forge line': 'Fireplace Doors - Bar Iron',
      'forge-line': 'Fireplace Doors - Bar Iron',
      'mesh masonry': 'Fireplace Doors - Mesh Doors',
      'laguna': 'Fireplace Doors - Laguna',
      'carolina sunrise': 'Fireplace Doors - Carolina / Panes',
      'carolina window pane': 'Fireplace Doors - Carolina / Panes',
      'carolina steel': 'Fireplace Doors - Carolina / Panes',
      'odyssey':       'Fireplace Doors - Carolina',
      'piccolo':       'Fireplace Doors - DS / Oak / Black / Crafts etc',
      '304 stainless': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'stainless steel': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'arden':    'Fireplace Doors - Avalon /Br /Ht / Ln',
      'openview': 'Fireplace Doors - Full View',
      'sierra window pane': 'Fireplace Doors - Columbia',
      'sierra arch':        'Fireplace Doors - Columbia',
      'sierra':             'Fireplace Doors - Columbia',
      'deepset arch conversion': 'Fireplace Doors - Inset / Inline',
      'deepset arch':            'Fireplace Doors - Inset / Inline',
      'deepset':                 'Fireplace Doors - Inset / Inline',
      'edgeline arch conversion':'Fireplace Doors - Inset / Inline',
      'edgeline arch':           'Fireplace Doors - Inset / Inline',
      'edgeline':                'Fireplace Doors - Inset / Inline',
      'smithline':'Fireplace Doors - Blacksmith',
      'heritage': 'Fireplace Doors - Heritage',
      'madrid':        'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'black rock':    'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'craftsman':     'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'hammered edge': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'banded scroll': 'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'oak tree':      'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'napa valley':   'Fireplace Doors - DS / Oak / Black / Crafts etc',
      'mantel':        'Fireplace Doors - Carolina / Panes',
      'milwaukee': 'Fireplace Doors - Milwaukee',
      'brooklyn':            'Fireplace Doors - Manhattan',
      'manhattan':           'Fireplace Doors - Manhattan',
      'slimlinepro':         'Fireplace Doors - Elite Thinline',
      'slim line pro':       'Fireplace Doors - Elite Thinline',
      'elite thinline':      'Fireplace Doors - Elite Thinline',
      'rustic':              'Fireplace Doors - Old World',
      'old world':           'Fireplace Doors - Old World',
      'metro':               'Fireplace Doors - Industrial',
      'industrial':          'Fireplace Doors - Industrial',
      'midway':              'Fireplace Doors - Transitional',
      'transitional':        'Fireplace Doors - Transitional',
      'timeless flames':     'Fireplace Doors - Vintage',
      'vintage':             'Fireplace Doors - Vintage',
      'aged iron':           'Fireplace Doors - Aged & Forged Iron',
      'aged & forged iron':  'Fireplace Doors - Aged & Forged Iron',
      'aged and forged iron':'Fireplace Doors - Aged & Forged Iron',
      'forged iron':         'Fireplace Doors - Aged & Forged Iron',
      'ashford':             'Fireplace Doors - Manhattan',
      'edgewood':            'Fireplace Doors - Manhattan',
      'plated':              'Fireplace Doors - Plated'
    };

    var groups = Object.keys(data);
    for (var alias in ALIASES) {
      if (prodTitle.indexOf(alias) !== -1 && data[ALIASES[alias]]) return ALIASES[alias];
    }

    /* Pass 1 — exact MODEL_NAMES match (unique, unambiguous product names) */
    var MODEL_NAMES = [
      'stiletto cutback',
      'ardmore','armitage','finley','belmont','brookfield','stiletto','silhouette',
      'cabot','rainbow','reflection','grande','medio','apex','bungalow','savannah',
      'carolina','legend','avalon','blacksmith','elite thinline','madrid',
      'hammered edge','craftsman','oak tree','black rock','bar iron',
      'original custom','old world','smithline','essex','lancaster','portland',
      'hudson','mantel','mke rail','camden','colt','farnsworth'
    ];
    var pass1 = [];
    for (var i = 0; i < groups.length; i++) {
      var gName = groups[i];
      var raw = gName.replace(/^Fireplace Doors\s*-\s*/i, '');
      var keywords = raw.split(/\s*[\/,]\s*/);
      var matchedChars = 0;
      for (var k = 0; k < keywords.length; k++) {
        var kw = keywords[k].trim().toLowerCase();
        if (MODEL_NAMES.indexOf(kw) !== -1 && prodTitle.indexOf(kw) !== -1) {
          matchedChars += kw.length;
        }
      }
      if (matchedChars > 0) pass1.push({ name: gName, score: matchedChars });
    }
    if (pass1.length === 1) return pass1[0].name;
    if (pass1.length > 1) {
      pass1.sort(function(a, b) { return b.score - a.score; });
      return pass1[0].name;
    }

    /* Pass 2 — longest-keyword fallback */
    groups.sort(function(a, b) { return b.length - a.length; });
    for (var j = 0; j < groups.length; j++) {
      var gName2 = groups[j];
      var raw2 = gName2.replace(/^Fireplace Doors\s*-\s*/i, '');
      var keywords2 = raw2.split(/\s*[\/,]\s*/);
      var matched = false;
      for (var m = 0; m < keywords2.length; m++) {
        var kw2 = keywords2[m].trim().toLowerCase();
        if (kw2.length < 4) continue;
        if (SKIP_WORDS.indexOf(kw2) !== -1) continue;
        if (prodTitle.indexOf(kw2) !== -1) { matched = true; break; }
      }
      if (matched) return gName2;
    }
    return groups.length ? groups[groups.length - 1] : null;
  }

  /* ── Find the data block for this product ──────────────────────
     Exposed on window for sibling IIFEs (samples modal). */
  function findGroupData() {
    var data = window.EF_CFG_DATA || {};
    var keys = Object.keys(data);
    if (!keys.length) return null;

    /* 1. Direct slug match — code-split file like "doors-cabot.js"
       sets data["doors-cabot"] (the slug itself, not the display name). */
    if (CFG_GROUP && data[CFG_GROUP]) return data[CFG_GROUP];

    /* 2. cfg v2's full alias + MODEL_NAMES + longest-keyword matching. */
    var matched = matchProductToGroup();
    if (matched && data[matched]) {
      console.log('[ef-orderform] Matched group:', matched);
      return data[matched];
    }

    /* 3. Last-resort fallback (very unlikely to reach here) */
    console.warn('[ef-orderform] Falling back to first group:', keys[0]);
    return data[keys[0]] || null;
  }
  /* Expose for sibling IIFEs that need finish list (samples modal). */
  window.EF_OF_FIND_GROUP = findGroupData;

  function whenDataReady(cb) {
    var start = Date.now();
    function poll() {
      var d = window.EF_CFG_DATA;
      var ok = d && Object.keys(d).length;
      if (ok) return cb(true);
      if (Date.now() - start > 8000) return cb(false);
      setTimeout(poll, 120);
    }
    poll();
  }

  /* ── Label/desc cleanup tables — copied 1:1 from ef-configurator-v2.js
     (lines 890-924 + 935-938). Old form runs raw EF_CFG_DATA labels through
     this filter so e.g. "Stainless Steel Mesh - Mesh Behind Glass[Extend
     Lead Time + 2-3 weeks]" becomes "Stainless Steel Mesh", and the desc
     is overridden by a clean fallback like "Premium stainless steel". */
  var FALLBACK_DESCS = {
    'Trackless Bi-Fold': 'Fully swing Bi-fold doors',
    'Bi-Fold': 'Fully swing Bi-fold doors',
    'Cabinet': 'Traditional hinged double doors',
    'Simplicity': 'Clean vertical bar',
    'Modern': 'Rectangular pull',
    'Birdcage': 'Ornate twisted design',
    'Infinity': 'Continuous loop handle',
    'Square': 'Angular modern pull',
    'Classic': 'Traditional curved handle',
    'Foundation': 'Solid minimal bar',
    'Contour': 'Ergonomic curved grip',
    'Contemporary': 'Sleek modern design',
    'Designer': 'Premium decorative handle',
    'Masonry': 'Traditional brick or stone fireplace',
    'Overlap Fit': 'Frame overlaps the opening edges',
    'Inside Fit': 'Frame sits inside the opening',
    'Regular Fit': 'Doors overlap the fireplace frame',
    'Flush Fit': 'Doors sit inside the fireplace frame',
    'Clear Glass': 'Standard clear tempered',
    'Grey': 'Tinted grey tempered',
    'Bronze': 'Tinted bronze tempered',
    'Black Glass': 'Tinted black tempered',
    'Wire Mesh Instead': 'Replaces glass with wire mesh',
    'Wire Mesh': 'Replaces glass with wire mesh',
    'Bevel Glass 1/2': 'Beveled edge tempered',
    'Bevel Glass 1': 'Wide beveled edge tempered',
    'No Mesh': 'Just glass doors',
    'Black Mesh': 'Pull-chain mesh',
    'Twin Gate': 'Two mesh doors',
    'Single Panel': 'Single mesh panel',
    'Stainless Steel': 'Premium stainless steel',
    'No Thank You': 'No draft control',
    'Yes': 'Add bottom draft control',
    /* Pattern variants — Carolina + Carolina Panes (DS) */
    'Standard Door': 'Clean unobstructed glass',
    'Center Bars': 'Vertical bar through middle',
    'Window Pane': 'Six-pane grid pattern',
    'Sunrise Window Pane': 'Radial sunrise grid above',
    'Eight Pane': 'Two-row eight-pane grid',
    'Arched Conversion': 'Arched top conversion frame',
    'Cathedral': 'Pointed-peak cathedral arch',
    /* Frame Width — premium products (Carolina, Legend) */
    '1.5" Frame': 'Slim 1.5-inch outer frame',
    '2" Frame': 'Standard 2-inch outer frame',
    '3" Frame': 'Wide 3-inch outer frame',
    '4" Frame': 'Extra-wide 4-inch outer frame',
    'Heavy Frame': 'Reinforced heavy-duty frame'
  };
  function cleanLabel(rawLabel, group) {
    if (!rawLabel) return '';
    var clean = rawLabel.replace(/\.\s*$/, '');
    /* For mesh/glass: take only part before " - " + strip [bracket notes]. */
    if (group === 'mesh' || group === 'glass') {
      clean = clean.split(' - ')[0].replace(/\[.*\]/, '').trim();
    }
    /* Gas-logs Fuel/Ignition native-variant labels carry a trailing price token
       ("Manual Safety Pilot +$192.20", "Match Lit Match Lit -$250.20"). Strip the
       price suffix and collapse an immediately-repeated phrase from messy imports. */
    if (group === 'fuel' || group === 'ignition') {
      clean = clean.replace(/\s*[-+]\s*\$[\d,]+(?:\.\d+)?\s*$/, '').trim();
      clean = clean.replace(/^(.+?)\s+\1$/i, '$1').trim(); /* "Match Lit Match Lit" → "Match Lit" */
    }
    return clean;
  }
  /* Premium inline-SVG icon for text-only Fuel/Ignition options (Real Fyre lists
     these as plain choices with no photo). Keyword-matched on the cleaned label.
     Color is set via CSS (.ef-cfg-card__icon). 28×28 viewBox, 1.6 stroke. */
  function efOptIcon(label, group) {
    var l = (label || '').toLowerCase();
    var S = function (paths) { return '<svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + paths + '</svg>'; };
    var flame = '<path d="M12 2.5c1.5 3 4.5 4.5 4.5 8.5a4.5 4.5 0 0 1-9 0c0-1.6.7-2.7 1.5-3.6.2 1 .8 1.8 1.7 2.1-.1-2.6.6-5 1.3-7z"/>';
    if (group === 'burner') {
      /* linear burner pan + flame ports */
      var pan = '<path d="M3 15.5h18"/><path d="M5 15.5v2a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2"/><path d="M7.5 15.5l.7-3M12 15.5v-3.2m4.5 3.2l-.7-3"/>';
      if (/stainless/.test(l)) return S(pan + '<path d="M18 4.2l.7 1.6 1.6.7-1.6.7-.7 1.6-.7-1.6-1.6-.7 1.6-.7z"/>'); /* + shine sparkle */
      return S(pan);
    }
    if (group === 'fuel') {
      if (/propane|lp\b|liquid/.test(l)) return S('<rect x="7" y="7" width="10" height="14" rx="2"/><path d="M10 7V5a2 2 0 0 1 4 0v2"/><path d="M9.5 3.5h5"/>'); /* tank */
      return S(flame); /* natural gas */
    }
    /* ignition */
    if (/electronic/.test(l)) return S('<rect x="4" y="9" width="16" height="9" rx="1.5"/><path d="M8 9V6m8 3V6M9 18v2m6-2v2"/><path d="M11 11.5l-1.5 2.5h3l-1.5 2.5"/>'); /* control module + bolt */
    if (/variable/.test(l)) return S('<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M8 8v8"/><circle cx="8" cy="13" r="1.6"/><path d="M16 8v8"/><circle cx="16" cy="9" r="1.6"/>'); /* remote w/ sliders */
    if (/remote|on.?off|automatic/.test(l)) return S('<rect x="7" y="3" width="10" height="18" rx="2.5"/><circle cx="12" cy="8" r="1.6"/><path d="M10 13h4m-4 3h4"/>'); /* remote */
    if (/manual|safety|pilot/.test(l)) return S('<circle cx="12" cy="13" r="6.5"/><path d="M12 13V8.5"/><path d="M12 2.5v2.5"/>'); /* control knob */
    if (/match/.test(l)) return S('<path d="M14 3l-1 5 3-1z"/><line x1="13.5" y1="6.5" x2="7" y2="20"/>' + '<path d="M7 20a2.2 2.2 0 1 0 0-.1z"/>'); /* match + flame tip */
    return S(flame);
  }
  /* Plain-language helper text for Fuel/Ignition options (keyword-matched). */
  function efOptDesc(label, group) {
    var l = (label || '').toLowerCase();
    if (group === 'burner') {
      if (/stainless/.test(l)) return 'Premium 304 stainless — won’t rust or warp. Lifetime warranty.';
      if (/\bg4\b/.test(l)) return 'Standard cast-iron burner — reliable, lowest cost.';
      return 'Premium G45 burner — more ports, fuller flame & ember bed.';
    }
    if (group === 'fuel') {
      if (/propane|lp\b|liquid/.test(l)) return 'For an LP / propane tank supply.';
      return 'Connects to your home natural-gas line.';
    }
    if (/millivolt/.test(l)) return 'Operate with a wall switch OR the included wireless remote — your choice. Standing pilot, no batteries needed.';
    if (/electronic/.test(l)) return 'Battery electronic ignition — no standing pilot, saves gas.';
    if (/variable/.test(l)) return 'Remote on/off plus dial the flame height up or down.';
    if (/on.?off|remote|automatic/.test(l)) return 'Turn the fire on & off from the remote.';
    if (/manual|safety|pilot/.test(l)) return 'Standing pilot with a manual safety shut-off knob.';
    if (/match/.test(l)) return 'Light it with a match — no valve. Lowest cost.';
    return '';
  }
  /* Map an Ignition option label → its Real Fyre kit model + photo key (window.EF_IGN_IMG).
     Order matters: electronic → low-profile variable → variable → on/off → manual → match. */
  function efIgnitionModel(label) {
    var l = (label || '').toLowerCase();
    if (/electronic|epk|non.?standing/.test(l))      return { key: 'epk-2',  model: 'EPK-2' };
    if (/modulating.*millivolt|millivolt.*variable/.test(l)) return { key: 'apk-15', model: '' };
    if (/millivolt/.test(l))                         return { key: 'apk-11', model: '' };
    if (/variable/.test(l) && /low|profile|apk.?17/.test(l)) return { key: 'apk-17', model: 'APK-17' };
    if (/variable/.test(l))                          return { key: 'apk-15', model: 'APK-15' };
    if (/on.?off|automatic|remote/.test(l))          return { key: 'apk-11', model: 'APK-11' };
    if (/manual|safety|spk|standing pilot/.test(l))  return { key: 'spk-26', model: 'SPK-26' };
    if (/match/.test(l))                             return { key: 'match',  model: '' };
    return { key: '', model: '' };
  }
  /* Fuel option → generated luxury image key (window.EF_FUEL_IMG). */
  function efFuelKey(label) {
    var l = (label || '').toLowerCase();
    if (/propane|lp\b|liquid/.test(l)) return 'propane';
    if (/natural|\bng\b/.test(l)) return 'natural-gas';
    return '';
  }
  /* Burner option → image key (window.EF_BURNER_IMG, optional — falls to SVG icon). */
  function efBurnerKey(label) {
    var l = (label || '').toLowerCase();
    if (/stainless/.test(l)) return 'g45-stainless';
    if (/\bg4\b/.test(l)) return 'g4';
    if (/g45|g46|standard|premium|steel|carbon/.test(l)) return 'g45';
    return '';
  }
  function cleanDesc(rawDesc, label, group) {
    /* Glass-color descs (Bronze, Grey, Clear Glass, Black Glass) live in the
       same fallback map but should ONLY apply to the glass group. Otherwise
       finish swatches like "Bronze Burst" / "Cast Bronze" inherit "Tinted
       bronze tempered" which is wrong. Skip lookup entirely for finishes —
       they have no useful desc anyway, just show the label. */
    if (group === 'finish') return '';
    /* Look up cleaner desc by keyword match (label contains key). Fallback
       to raw desc if no match. */
    for (var key in FALLBACK_DESCS) {
      if (label.toLowerCase().indexOf(key.toLowerCase()) !== -1) {
        return FALLBACK_DESCS[key];
      }
    }
    return rawDesc || '';
  }

  /* ── Popularity stats for finish badges (configurator v2 pattern) ── */
  var EF_POPULAR_FINISHES = {
    'matte black':    { rank: 1, pct: 47 },
    'textured black': { rank: 2, pct: 18 },
    'charcoal':       { rank: 3, pct: 11 }
  };

  /* ── Special render for finish group: big square swatches + badge + stat
     Each card is a large 1:1 swatch image + label + Included/+$X + popular
     badge overlay if matched in EF_POPULAR_FINISHES. */
  function renderFinishCards(detailsEl, options) {
    var list = detailsEl.querySelector('.ef-of__cd-list');
    if (!list) return;
    list.innerHTML = '';
    if (!options || !options.length) {
      list.innerHTML = '<p style="padding:12px;font-size:13px;color:#8A8579;text-align:center;">Not available for this product.</p>';
      return;
    }

    /* 2-col grid for finish — narrower cards cut off "Used in X% of orders"
       at 3-col, so use the default 2-col which gives each card ~50% more
       horizontal width. Matches the old form's clean fit (#125 reference). */
    var grid = document.createElement('div');
    grid.className = 'ef-cfg-group__grid ef-of__finish-cards';

    options.forEach(function (opt, idx) {
      var lbl = cleanLabel(opt.label, 'finish');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ef-cfg-card ef-of__cd-opt ef-of__finish-card';
      btn.dataset.idx = idx;
      btn.dataset.label = lbl;
      btn.dataset.rawLabel = opt.label || '';
      btn.dataset.price = opt.price || 0;
      btn.dataset.variantId = opt.variantId || '';
      btn.dataset.desc = '';
      btn.dataset.img = opt.img || '';
      btn.dataset.previewImg = opt.previewImg || '';
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', 'false');

      var pop = EF_POPULAR_FINISHES[lbl.toLowerCase().trim()];
      var html = '';
      if (pop) {
        html += '<span class="ef-of__finish-badge">MOST POPULAR</span>';
      }
      html += '<span class="ef-cfg-card__check"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
      var imgUrl = opt.img || opt.previewImg || '';
      if (imgUrl) {
        html += '<span class="ef-cfg-card__img ef-of__finish-img"><img src="' + imgUrl.replace(/ /g, '%20') + '" alt="' + escapeHtml(lbl) + '" loading="lazy"></span>';
      } else {
        html += '<span class="ef-cfg-card__img ef-cfg-img-broken"></span>';
      }
      html += '<span class="ef-cfg-card__body">';
      html += '<span class="ef-cfg-card__title">' + escapeHtml(lbl) + '</span>';
      var priceStatus = (opt.price && opt.price > 0)
        ? '+' + moneyDollars(opt.price)
        : 'Included';
      html += '<span class="ef-of__finish-status">' + priceStatus + '</span>';
      if (pop) {
        html += '<span class="ef-of__finish-stat">Used in ' + pop.pct + '% of orders</span>';
      }
      html += '</span>';

      btn.innerHTML = html;
      grid.appendChild(btn);
    });

    list.appendChild(grid);

    /* Persistent info tip at top of finish dropdown — encourages user to
       click and watch the gallery preview update live with each color. */
    var hint = document.createElement('div');
    hint.className = 'ef-of__finish-hint';
    hint.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>'
      + '<span>Pick a color and see it live on the gallery.</span>';
    list.insertBefore(hint, list.firstChild);
  }

  /* ── Mesh image override based on currently-selected door_type.
     Mirror cfg v2 (lines ~978-988): bi-fold vs cabinet × twin-gate vs single
     panel each have a dedicated illustration. Used when rendering mesh cards
     so the visual matches the buyer's door choice. ─────────────────────── */
  var MESH_IMG_MAP = {
    'bifold-twin':   'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/Mesh_Gate_1.png?v=1777443879',
    'bifold-single': 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/bi-fold_one_panel_1.png?v=1776814923',
    'cabinet-twin':  'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/Mesh_Gate_1.png?v=1777443879',
    'cabinet-single': 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/cabinet_one_panel_1.png?v=1776814923'
  };
  /* "No mesh / just glass doors" option — show a pure-glass door illustration
     matching the door_type chosen in step 8. User-provided URLs (2026-05-08):
     bi-fold → bifold_fireplace_doors_transparent_1.png
     cabinet → Cabinet_D_11_1.png */
  var NO_MESH_IMG_MAP = {
    'bifold-twin':    'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/bifold_fireplace_doors_transparent_1.png?v=1778277912',
    'bifold-single':  'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/bifold_fireplace_doors_transparent_1.png?v=1778277912',
    'cabinet-twin':   'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/Cabinet_D_11_1.png?v=1778277912',
    'cabinet-single': 'https://cdn.shopify.com/s/files/1/0070/9502/5746/files/Cabinet_D_11_1.png?v=1778277912'
  };
  function pickMeshImage(meshLabel, doorTypeLabel) {
    var ml = (meshLabel || '').toLowerCase();
    var dl = (doorTypeLabel || '').toLowerCase();
    var bi  = dl.indexOf('bi-fold') !== -1 || dl.indexOf('bifold') !== -1;
    var cab = dl.indexOf('cabinet') !== -1;
    /* Default door category when door_type doesn't say bi/cab (some Cabot
       configs use "Inside Fit" / "Overlap Fit" labels instead). Cabinet
       is the most common Cabot style so it's the safe default — and
       crucially, NOT arch. Without this, Twin Gate Mesh / Single Panel
       Mesh fell back to opt.img which on Cabot was an ARCH-shape PNG. */
    var doorCat = bi ? 'bifold' : 'cabinet';
    var tw  = ml.indexOf('twin gate') !== -1;
    var one = ml.indexOf('single panel') !== -1 || ml.indexOf('one panel') !== -1;
    var noMesh = ml.indexOf('no mesh') !== -1 || ml.indexOf('just glass') !== -1 || ml.indexOf('without mesh') !== -1 || ml.indexOf('glass only') !== -1;
    /* door_type carries its own twin/single info — derive when mesh label
       doesn't (the no-mesh option is a single card). */
    var dtTwin   = dl.indexOf('twin') !== -1;
    var dtSingle = dl.indexOf('single') !== -1 || dl.indexOf('one panel') !== -1;
    if (noMesh) {
      var noMeshKey = doorCat + '-' + (dtSingle ? 'single' : 'twin');
      return NO_MESH_IMG_MAP[noMeshKey] || NO_MESH_IMG_MAP[doorCat + '-twin'];
    }
    if (tw)  return MESH_IMG_MAP[doorCat + '-twin'];
    if (one) return MESH_IMG_MAP[doorCat + '-single'];
    return null;
  }

  /* ── Render option cards using the EXACT pattern from ef-configurator-v2.js
     (function `renderOption` ~line 996). This way the card visuals are 1:1
     with the old configurator (.ef-cfg-card + .ef-cfg-group__grid--3 layout,
     fallback gradient on missing images, uniform 3/2 aspect, etc.).
     `ef-configurator-v2.css` is loaded by the template. ────────────────── */
  function renderCards(detailsEl, options) {
    /* Special render for finish group: big square swatches + popular badge. */
    if (detailsEl.dataset.group === 'finish') {
      return renderFinishCards(detailsEl, options);
    }
    var list = detailsEl.querySelector('.ef-of__cd-list');
    if (!list) return;
    list.innerHTML = '';
    if (!options || !options.length) {
      list.innerHTML = '<p style="padding:12px;font-size:13px;color:#8A8579;text-align:center;">Not available for this product.</p>';
      return;
    }

    /* Use 2-column grid (default .ef-cfg-group__grid) — bigger cards with
        3/2 aspect images, matching the early POC sizing user preferred.
        Configurator CSS: .ef-cfg-group__grid → minmax(0,1fr) minmax(0,1fr). */
    var grid = document.createElement('div');
    grid.className = 'ef-cfg-group__grid';

    var group = detailsEl.dataset.group;
    options.forEach(function (opt, idx) {
      /* Run raw label + desc through the same cleanup the old configurator
         applies — so "Stainless Steel Mesh - Mesh Behind Glass[Extend Lead
         Time + 2-3 weeks]" → "Stainless Steel Mesh" + "Premium stainless steel". */
      var lbl = cleanLabel(opt.label, group);
      var dsc = cleanDesc(opt.desc, lbl, group);
      if (!dsc && (group === 'fuel' || group === 'ignition' || group === 'burner')) dsc = efOptDesc(lbl, group);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ef-cfg-card ef-of__cd-opt';
      btn.dataset.idx = idx;
      btn.dataset.label = lbl;          /* cleaned label used everywhere downstream */
      btn.dataset.rawLabel = opt.label || ''; /* keep raw for cart properties if needed */
      btn.dataset.price = opt.price || 0;
      btn.dataset.variantId = opt.variantId || '';
      btn.dataset.desc = dsc;
      btn.dataset.previewImg = opt.previewImg || '';
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', 'false');

      var html = '<span class="ef-cfg-card__check"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
      /* Mobile zoom button — top-left, hidden via cfg v2 CSS unless
         viewport ≤767px. Tap → opens fullscreen modal with big image
         + label + desc + "Choose this" CTA. data-cfg-zoom attr matched
         by event delegate at the end of this file. */
      html += '<span class="ef-cfg-card__zoom" role="button" tabindex="0" aria-label="View larger image" data-cfg-zoom>'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>'
            + '</span>';
      var imgUrl = opt.img || opt.previewImg || '';
      /* Vendor-specific direct option photos (e.g. Grand Canyon's own valve/burner shots),
         keyed by group + lowercased label. Takes priority over the keyword maps below. */
      if (!imgUrl && window.EF_OPT_IMG && window.EF_OPT_IMG[group]) {
        var directImg = window.EF_OPT_IMG[group][(lbl || '').toLowerCase().trim()];
        /* product-on-white hardware photos (GC/Hargrove) → contain on a white tile */
        if (directImg) { imgUrl = directImg; if (group === 'burner') btn.classList.add('ef-cfg-card--fuelimg'); }
      }
      /* Ignition: show the real Real Fyre kit photo (hosted theme asset) + model #. */
      var ignMeta = null;
      if (group === 'ignition') {
        ignMeta = efIgnitionModel(lbl);
        if (!imgUrl && ignMeta.key && window.EF_IGN_IMG && window.EF_IGN_IMG[ignMeta.key]) imgUrl = window.EF_IGN_IMG[ignMeta.key];
        /* Match Lit is our generated luxury image (ivory bg); the SPK/APK/EPK kits are
           white-bg scraped product photos → different card backdrops. */
        btn.classList.add(ignMeta.key === 'match' ? 'ef-cfg-card--lux' : 'ef-cfg-card--ign');
      }
      if (group === 'fuel') {
        var fk = efFuelKey(lbl);
        if (!imgUrl && fk && window.EF_FUEL_IMG && window.EF_FUEL_IMG[fk]) { imgUrl = window.EF_FUEL_IMG[fk]; btn.classList.add('ef-cfg-card--fuelimg'); }
      }
      if (group === 'burner') {
        var bk = efBurnerKey(lbl);
        if (!imgUrl && bk && window.EF_BURNER_IMG && window.EF_BURNER_IMG[bk]) { imgUrl = window.EF_BURNER_IMG[bk]; btn.classList.add('ef-cfg-card--fuelimg'); }
        if (/stainless/.test(lbl.toLowerCase())) btn.classList.add('ef-cfg-card--burner-ss');
      }
      /* Mesh group: override image based on door_type selection so the
         illustration shows the correct combination (bi-fold + twin gate, etc.) */
      if (group === 'mesh') {
        var doorSel = state.selections.door_type;
        if (doorSel) {
          var dyn = pickMeshImage(lbl, doorSel.label);
          if (dyn) imgUrl = dyn;
        }
      }
      /* Persist the resolved (override-applied) URL so onOptClick uses it
         when updating the summary thumb. Without this, btn.dataset.img
         would hold the original opt.img and the closed-state thumb
         wouldn't reflect the door_type-aware mesh override. */
      btn.dataset.img = imgUrl;
      if (imgUrl) {
        html += '<span class="ef-cfg-card__img"><img src="' + imgUrl.replace(/ /g, '%20') + '" alt="' + escapeHtml(lbl) + '" loading="lazy" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'ef-cfg-img-broken\')"></span>';
      } else if (group === 'fuel' || group === 'ignition' || group === 'burner') {
        /* Real Fyre lists Fuel/Ignition/Burner as plain text choices (no photo). Render a
           premium SVG icon tile instead of a blank/gray box. */
        btn.classList.add('ef-cfg-card--icon');
        html += '<span class="ef-cfg-card__icon" aria-hidden="true">' + efOptIcon(lbl, group) + '</span>';
      } else {
        btn.classList.add('ef-cfg-card--textonly');
      }
      html += '<span class="ef-cfg-card__body">';
      html += '<span class="ef-cfg-card__title">' + escapeHtml(lbl) + '</span>';
      /* RF model numbers (SPK-26 etc.) are Real-Fyre-specific — only show for RF. */
      var glRF = window.EF_GL && window.EF_GL[root.dataset.productHandle];
      var isRFvendor = glRF && /real fyre/i.test(glRF.vendor || '');
      if (ignMeta && ignMeta.model && isRFvendor) html += '<span class="ef-cfg-card__model">MODEL: ' + escapeHtml(ignMeta.model) + '</span>';
      if (dsc) html += '<span class="ef-cfg-card__desc">' + escapeHtml(dsc) + '</span>';
      if (group === 'ignition') {
        /* Only Real Fyre folds the ignition cost into the Burner step (bareBase model),
           so its pilot TYPE shows free. EVERY other line — Formation Creation, Hargrove,
           AND Grand Canyon (which has a burner axis too) — prices the ignition on its own
           variant, so show +$X. Gate on bareBase, NOT on hasBurnerAxis: GC has a burner
           axis yet still needs the ignition surcharge displayed. 2026-06-23 */
        var glI = window.EF_GL && window.EF_GL[root.dataset.productHandle];
        var rfBurnerModel = glI && glI.bareBase;
        if (!rfBurnerModel && opt.price && opt.price > 0) {
          html += '<span class="ef-cfg-card__price">+' + moneyDollars(opt.price) + '</span>';
        }
      } else if (group === 'burner') {
        /* RF (has bareBase): "Included" placeholder, real cost filled by updateBurnerAvailability.
           Non-RF (Grand Canyon etc., no bareBase): show the option's own price delta so paid
           burner upgrades (e.g. 3 Burner) display +$X on the card, not just in the summary. */
        var glBp = window.EF_GL && window.EF_GL[root.dataset.productHandle];
        if (glBp && glBp.bareBase) {
          html += '<span class="ef-cfg-card__price ef-cfg-card__price--inc">Included</span>';
        } else if (opt.price && opt.price > 0) {
          html += '<span class="ef-cfg-card__price">+' + moneyDollars(opt.price) + '</span>';
        } else {
          html += '<span class="ef-cfg-card__price ef-cfg-card__price--inc">Included</span>';
        }
      } else if (opt.price && opt.price > 0) {
        html += '<span class="ef-cfg-card__price">+' + moneyDollars(opt.price) + '</span>';
      }
      html += '</span>';

      btn.innerHTML = html;
      grid.appendChild(btn);
    });

    list.appendChild(grid);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /* ── Selection handler: click option card → save state + close ── */
  function onOptClick(e) {
    /* Skip if user tapped the magnify icon — let the zoom modal handler
       (efOfZoomModalInit at end of file) catch that event instead. */
    if (e.target && e.target.closest && e.target.closest('[data-cfg-zoom]')) return;
    var btn = e.target.closest('.ef-of__cd-opt');
    if (!btn) return;
    if (btn.classList.contains('ef-of__cd-opt--unavail')) return; /* disabled (e.g. Stainless on On/Off) */
    var detailsEl = btn.closest('.ef-of__cd');
    var group = detailsEl.dataset.group;

    /* Update aria-selected on siblings */
    detailsEl.querySelectorAll('.ef-of__cd-opt').forEach(function(b){ b.setAttribute('aria-selected', 'false'); });
    btn.setAttribute('aria-selected', 'true');

    /* Update <summary> to show selected option as the card */
    var thumb = detailsEl.querySelector('.ef-of__cd-thumb');
    var label = detailsEl.querySelector('.ef-of__cd-selected-label');
    var desc = detailsEl.querySelector('.ef-of__cd-selected-desc');
    var img = btn.dataset.img;
    var lbl = btn.dataset.label;
    var dsc = btn.dataset.desc;
    var price = parseInt(btn.dataset.price || '0', 10);

    if (img) {
      thumb.innerHTML = '<img src="' + img + '" alt="' + escapeHtml(lbl) + '" loading="lazy">';
    } else {
      thumb.innerHTML = '<span class="ef-of__cd-thumb-placeholder"></span>';
    }
    /* When this group has only ONE option (e.g. Cabot's Fireplace Type =
       "Masonry" only, Fit Type = "Overlap" only), append " Only" to the
       displayed label so users immediately understand there's no choice
       to make. The underlying btn.dataset.label stays clean — the cart
       properties still receive "Masonry" / "Overlap", not "Masonry Only". */
    var siblingCount = detailsEl.querySelectorAll('.ef-of__cd-opt').length;
    label.textContent = siblingCount === 1 ? (lbl + ' Only') : lbl;
    /* Also collapse the dropdown chevron + disable expansion when locked
       to a single option — clicking does nothing useful. */
    if (siblingCount === 1) {
      detailsEl.classList.add('ef-of__cd--single');
    } else {
      detailsEl.classList.remove('ef-of__cd--single');
    }
    desc.textContent = dsc || (price > 0 ? '+' + moneyDollars(price) : 'Included');

    detailsEl.dataset.selected = 'true';
    detailsEl.open = false; /* Close after pick */

    state.selections[group] = {
      label: lbl, price: price, variantId: btn.dataset.variantId || '',
      img: img, desc: dsc, previewImg: btn.dataset.previewImg || '',
      rawLabel: btn.dataset.rawLabel || lbl,   /* full native option value (for variant resolution) */
      idx: parseInt(btn.dataset.idx || '-1', 10),
    };

    /* When finish is picked, swap the main gallery image to show the
       door rendered with this finish (data has previewImg per finish). */
    if (group === 'finish' && state.selections[group].previewImg) {
      swapGalleryPreview(state.selections[group].previewImg);
    }

    /* When door_type changes, re-render the mesh cards so their images
       match the picked door style (bi-fold vs cabinet variants).
       Mirror cfg v2 lines 1177-1192. Preserves prior mesh selection +
       re-applies AI rec tip/badge if AI analysis ran. */
    if (group === 'door_type') {
      var meshDetails = root.querySelector('.ef-of__cd[data-group="mesh"]');
      if (meshDetails) {
        var prevMesh = state.selections.mesh ? state.selections.mesh.label : null;
        var groupData = findGroupData();
        if (groupData && groupData.mesh) {
          renderCards(meshDetails, groupData.mesh);
          /* Re-apply the previously-selected mesh card after re-render */
          if (prevMesh) {
            var opts = meshDetails.querySelectorAll('.ef-of__cd-opt');
            for (var i = 0; i < opts.length; i++) {
              if (opts[i].dataset.label === prevMesh) {
                onOptClick({ target: opts[i], currentTarget: opts[i] });
                meshDetails.open = false;
                break;
              }
            }
          }
          /* Re-apply AI tip + badge after re-render so user doesn't lose advice. */
          if (typeof reapplyAiRecsForGroup === 'function') reapplyAiRecsForGroup('mesh');
        }
      }
    }

    recomputeTotal();

    /* Cross-axis availability: when Fuel/Ignition changes, re-evaluate which
       Burner options Real Fyre actually offers for that combo. */
    if (group === 'fuel' || group === 'ignition') updateBurnerAvailability();
  }

  /* Disable a Burner card when NO native variant exists for the current
     Fuel + Ignition + that burner material (Real Fyre offers Stainless only on
     Match Lit / Manual / Electronic — not On/Off, Variable, High-Capacity).
     If the chosen burner becomes unavailable, snap back to the first available
     (Standard Steel) so a valid variant always resolves. */
  function updateBurnerAvailability() {
    var gl = window.EF_GL && window.EF_GL[root.dataset.productHandle];
    if (!gl || !gl.options) return;
    var bIdx = -1;
    for (var i = 0; i < gl.options.length; i++) { if (gl.options[i].key === 'burner') { bIdx = i; break; } }
    if (bIdx < 0) return;
    var bDetails = root.querySelector('.ef-of__cd[data-group="burner"]');
    if (!bDetails) return;
    var bareBase = gl.bareBase || 0; /* cents — log set + size, no burner */
    var firstAvail = null, selectedUnavail = false;
    bDetails.querySelectorAll('.ef-of__cd-opt').forEach(function (card) {
      var bLabel = card.dataset.rawLabel || card.dataset.label;
      var match = null;
      gl.variants.some(function (v) {
        for (var k = 0; k < gl.options.length; k++) {
          if (k === bIdx) { if (v.opts[k] !== bLabel) return false; }
          else { var s = state.selections[gl.options[k].key]; if (s && v.opts[k] !== s.rawLabel) return false; }
        }
        match = v; return true;
      });
      var exists = !!match;
      card.classList.toggle('ef-of__cd-opt--unavail', !exists);
      card.setAttribute('aria-disabled', exists ? 'false' : 'true');
      /* Show the REAL burner cost (variant total − bare log set) for the current
         ignition — e.g. Match Lit G4 = +$367.20, Electronic G45 = +$1,491.30. */
      if (exists && bareBase) {
        var costCents = match.price - bareBase;
        card.dataset.price = (costCents / 100).toFixed(2);
        var priceEl2 = card.querySelector('.ef-cfg-card__price');
        if (priceEl2) { priceEl2.textContent = costCents > 0 ? '+' + moneyDollars(costCents / 100) : 'Included'; priceEl2.classList.toggle('ef-cfg-card__price--inc', costCents <= 0); }
      }
      if (exists && !firstAvail) firstAvail = card;
      if (!exists && card.getAttribute('aria-selected') === 'true') selectedUnavail = true;
    });
    if (selectedUnavail && firstAvail) { onOptClick({ target: firstAvail, currentTarget: firstAvail }); bDetails.open = false; }
  }

  /* ── Populate all dropdowns from data ─────────────────────────── */
  function populateAll() {
    var groupData = findGroupData();
    if (!groupData) {
      msg('Configurator data did not load. Please refresh or call (949) 619-7824.', 'err');
      return;
    }
    /* Premium products (Carolina, Legend, etc.) have Inside/Overlap mixed
       with Regular/Flush in fit_type. Cfg v2 splits these into 2 dropdowns:
       fit_type = Inside + Overlap, door_fit = Regular + Flush. We mirror
       that split here by precomputing the synthetic door_fit + filtered
       fit_type before render. Mirrors ef-configurator-v2.js:840-850. */
    var isPremium = (root.dataset.cfgGroup || '').length > 0 &&
                    document.querySelector('.ef-of__cd[data-group="door_fit"]') !== null;
    if (isPremium && groupData.fit_type) {
      var srcFit = groupData.fit_type;
      groupData = Object.assign({}, groupData);
      groupData.door_fit = srcFit.filter(function (o) {
        var l = (o.label || '').toLowerCase();
        return l.indexOf('regular') !== -1 || l.indexOf('flush') !== -1;
      });
      groupData.fit_type = srcFit.filter(function (o) {
        var l = (o.label || '').toLowerCase();
        return l.indexOf('regular') === -1 && l.indexOf('flush') === -1;
      });
    }
    details.forEach(function (d) {
      var group = d.dataset.group;
      var opts = groupData[group];
      /* Hide dropdowns whose data block is empty (e.g. pattern on non-Carolina
         premium products) — keeps the field count honest. */
      if (!opts || !opts.length) {
        var fs = d.closest('.ef-of__field');
        if (fs) fs.style.display = 'none';
        return;
      }
      renderCards(d, opts);
    });
    /* After hiding empty fields, RENUMBER the step legends so users see
       sequential 1..N instead of holes (e.g. 10, 11, 13, 14 when step 12
       was hidden). Liquid pre-bakes numbers; JS re-syncs visible-only. */
    var n = 1;
    root.querySelectorAll('.ef-of__field').forEach(function (fs) {
      if (fs.style.display === 'none') return;
      var num = fs.querySelector('.ef-of__legend-num');
      if (num) num.textContent = String(n);
      n++;
    });
    /* Bind clicks */
    root.addEventListener('click', onOptClick);

    /* 2026-05-08 — Preselect the first option of every dropdown so the form
       starts in a "ready to add to cart" state. User explicitly requested:
       no empty placeholders, no "Choose finish…" stubs. Simulates a click
       on the first .ef-of__cd-opt of each <details> without opening it. */
    details.forEach(function (d) {
      var first = d.querySelector('.ef-of__cd-opt');
      if (!first) return;
      /* Use the same selection logic as user click — but keep <details>
         closed so the page doesn't expand 8 dropdowns at once. */
      var fakeEvt = { target: first, currentTarget: first };
      onOptClick(fakeEvt);
      d.open = false;
    });
    /* Initial burner availability pass (default Match Lit offers Stainless). */
    updateBurnerAvailability();
  }

  /* Parse a dimension string into a decimal inches value.
     Supports plain numbers ("36", "36.5"), mixed ("36 1/4" → 36.25),
     and pure fractions ("1/2" → 0.5). Returns NaN if unparseable. */
  function parseInches(raw) {
    if (raw == null) return NaN;
    var s = String(raw).trim();
    if (!s) return NaN;
    /* Mixed: "36 1/4" or "36-1/4" */
    var mix = s.match(/^(\d+(?:\.\d+)?)\s*[-\s]\s*(\d+)\s*\/\s*(\d+)$/);
    if (mix) {
      var whole = parseFloat(mix[1]);
      var num = parseFloat(mix[2]);
      var den = parseFloat(mix[3]);
      if (den) return whole + num / den;
    }
    /* Pure fraction: "1/2" */
    var frac = s.match(/^(\d+)\s*\/\s*(\d+)$/);
    if (frac) {
      var n = parseFloat(frac[1]), d = parseFloat(frac[2]);
      if (d) return n / d;
    }
    /* Plain decimal */
    return parseFloat(s);
  }

  /* ── United Inches → size tier match ──────────────────────────── */
  function onDimChange() {
    var w = parseInches(widthInput.value);
    var h = parseInches(heightInput.value);
    if (!w || !h || isNaN(w) || isNaN(h)) {
      unitedEl.textContent = '—';
      matchEl.hidden = true;
      state.sizeSel = null;
      variantInput.value = BASE_VARIANT_ID;
      recomputeTotal();
      return;
    }
    var ui = w + h;
    unitedEl.textContent = ui;
    var groupData = findGroupData();
    if (!groupData || !groupData.size) return;
    /* Each size: { label: "Small: under 65 (W+H)", price, variantId }
       Parse the threshold from label. */
    var matched = null;
    for (var i = 0; i < groupData.size.length; i++) {
      var s = groupData.size[i];
      if (sizeMatches(s.label, ui)) { matched = s; break; }
    }
    if (matched) {
      state.sizeSel = matched;
      matchEl.hidden = false;
      /* Format like the previous order form:
           "Opening Size W + H = Medium: 65-77 +$50"
         Strip trailing "(W+H)" suffix from the label since the prefix
         "Opening Size W + H =" already says it. Append "+$XX" only when
         there's an upcharge. */
      var lbl = (matched.label || '').replace(/\s*\(W\+H\)\s*$/i, '').trim();
      matchTier.textContent = lbl;
      matchPrice.textContent = matched.price > 0 ? '+' + moneyDollars(matched.price) : '';
      if (matched.variantId) {
        variantInput.value = matched.variantId;
      }
    } else {
      matchEl.hidden = true;
      state.sizeSel = null;
    }
    recomputeTotal();
  }

  function sizeMatches(label, ui) {
    /* Label patterns:
       - "Small: under 65 (W+H)"
       - "Medium: 65-77 (W+H)"
       - "Large: 78+ (W+H)"
       - "XXL: 90+ (W+H)" */
    var m = label.match(/under\s*(\d+)/i);
    if (m) return ui < parseFloat(m[1]);
    m = label.match(/(\d+)\s*[-–]\s*(\d+)/);
    if (m) return ui >= parseFloat(m[1]) && ui < parseFloat(m[2]) + 1;
    m = label.match(/(\d+)\s*\+/);
    if (m) return ui >= parseFloat(m[1]);
    return false;
  }

  /* ── Recompute total ─────────────────────────────────────────── */
  /* BASE_PRICE is in cents. Surcharge prices are in DOLLARS — convert to
     cents before adding. Itemized breakdown: render one line per surcharge
     so the user sees "+ Fireplace Type (Masonry) +$140" etc. like the
     configurator review step. */
  var GROUP_LABELS = {
    fireplace_type: 'Fireplace Type',
    firebox_type:   'Firebox Type',
    fit_type:       'Install Option',
    finish:         'Finish',
    handle:         'Handle',
    glass:          'Glass',
    mesh:           'Mesh Screen',
    door_type:      'Door Type',
    draft_control:  'Draft Control'
  };

  /* Resolve the ONE native variant matching ALL chosen option axes (Fuel/Burner/Ignition/…).
     Returns the variant only when every axis is chosen (or the product is single-variant). */
  function resolveNativeVariant(gl) {
    if (!gl || !gl.variants || !gl.variants.length) return null;
    var opts = gl.options || [];
    if (!opts.length) return gl.variants[0];
    var sel = opts.map(function (o) { var s = state.selections[o.key]; return s ? s.rawLabel : null; });
    if (sel.some(function (x) { return x == null; })) return null;
    for (var i = 0; i < gl.variants.length; i++) {
      var v = gl.variants[i], ok = true;
      for (var k = 0; k < opts.length; k++) { if (v.opts[k] !== sel[k]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  function recomputeTotal() {
    var basePrice = BASE_PRICE;
    var surTotalDollars = 0;
    /* Build ordered list of surcharge entries: size first, then per-group selections. */
    var lines = [];
    if (state.sizeSel && state.sizeSel.price) {
      surTotalDollars += state.sizeSel.price;
      var sizeLbl = (state.sizeSel.label || '').replace(/\s*\(W\+H\)\s*$/i, '').trim();
      lines.push({ label: 'Size (' + sizeLbl + ')', dollars: state.sizeSel.price });
    }
    /* Iterate selections in the order their <details> appear in DOM
       (= the natural Step 2 → 9 order) */
    var detailsList = root.querySelectorAll('.ef-of__cd');
    detailsList.forEach(function (d) {
      var k = d.dataset.group;
      var s = state.selections[k];
      if (s && s.price && s.price > 0) {
        surTotalDollars += s.price;
        var groupLbl = GROUP_LABELS[k] || k;
        lines.push({ label: groupLbl + ' (' + s.label + ')', dollars: s.price });
      }
    });
    var surTotalCents = Math.round(surTotalDollars * 100);
    var total = basePrice + surTotalCents;
    /* Native-variant mode: once every axis is chosen, the resolved variant's price is exact
       (handles non-additive multi-axis pricing on Grand Canyon's Fuel×Burner×Ignition). */
    var gl0 = window.EF_GL && window.EF_GL[root.dataset.productHandle];
    var nv = resolveNativeVariant(gl0);
    if (nv && nv.price) total = nv.price;

    /* Gas-log RF model: show Base = bare Log Set (logs + size), then the Burner & Pilot
       as one priced line = variant total − bare base. Mirrors realfyrestore. */
    if (nv && nv.price && gl0 && gl0.bareBase) {
      var bb = gl0.bareBase;
      var burnerCents = nv.price - bb;
      var burSel = state.selections.burner ? state.selections.burner.label : '';
      var ignSel = state.selections.ignition ? state.selections.ignition.label : '';
      baseAmt.textContent = money(bb);
      if (totalLines) {
        totalLines.innerHTML = burnerCents > 0
          ? '<div class="ef-of__total-row ef-of__total-row--itemized"><span class="ef-of__total-label">+ Burner &amp; Pilot (' + escapeHtml([burSel, ignSel].filter(Boolean).join(' · ')) + ')</span><span class="ef-of__total-amt">+' + moneyDollars(burnerCents / 100) + '</span></div>'
          : '';
      }
      totalAmt.textContent = money(total);
      atcPrice.textContent = money(total);
      if (priceEl) priceEl.textContent = money(total);
      return;
    }

    baseAmt.textContent = money(basePrice);
    /* Render itemized lines */
    if (totalLines) {
      totalLines.innerHTML = lines.map(function (l) {
        return '<div class="ef-of__total-row ef-of__total-row--itemized">'
          + '<span class="ef-of__total-label">+ ' + escapeHtml(l.label) + '</span>'
          + '<span class="ef-of__total-amt">+' + moneyDollars(l.dollars) + '</span>'
          + '</div>';
      }).join('');
    }
    totalAmt.textContent = money(total);
    atcPrice.textContent = money(total);
    if (priceEl) priceEl.textContent = money(total);
  }

  /* ── Swap the main gallery image on finish change ──────────────
     Targets the swiper-active slide first; falls back to the first
     <img> inside .ef-pd-gallery if no swiper instance is found. */
  function swapGalleryPreview(url) {
    if (!url) return;
    /* 1. Try to find the active swiper slide image */
    var active = document.querySelector('#efGallerySwiper .swiper-slide-active img, #efGallerySwiper .swiper-slide-visible img');
    if (active) { active.src = url; active.srcset = ''; return; }
    /* 2. Fallback: first slide image */
    var first = document.querySelector('#efGallerySwiper .swiper-slide img');
    if (first) { first.src = url; first.srcset = ''; return; }
    /* 3. Last fallback: any image in gallery */
    var any = document.querySelector('.ef-pd-gallery img');
    if (any) { any.src = url; any.srcset = ''; }
  }

  /* File label + drag-drop for the Step 10 drop-zone. The <label> wraps
     icon + text, and the underlying <input type=file> is hidden — clicking
     anywhere in the dashed box opens the picker via the for= attribute.
     Drop event populates input.files so the change handler fires too.
     After upload: the dashed area swaps to a 120px thumbnail of the photo
     + filename + Replace/Remove actions. */
  if (fileInput && fileLabel) {
    var fileDrop = document.getElementById('efOfFileDrop');
    var fileIcon = fileDrop ? fileDrop.querySelector('.ef-of__upload-icon') : null;
    var fileHint = fileDrop ? fileDrop.querySelector('.ef-of__upload-hint') : null;

    /* Lazily-created preview container — sits where the + icon was. */
    var previewWrap = null;
    function showPreview(dataUrl, fileName) {
      if (!fileDrop) return;
      if (!previewWrap) {
        previewWrap = document.createElement('div');
        previewWrap.className = 'ef-of__upload-preview';
        previewWrap.innerHTML =
          '<img class="ef-of__upload-preview__img" alt="Uploaded photo">' +
          '<button type="button" class="ef-of__upload-preview__remove" aria-label="Remove photo">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="6" y1="18" x2="18" y2="6"/></svg>' +
          '</button>';
        /* Mount BEFORE the existing icon so it occupies the same visual slot. */
        if (fileIcon && fileIcon.parentNode === fileDrop) {
          fileDrop.insertBefore(previewWrap, fileIcon);
        } else {
          fileDrop.insertBefore(previewWrap, fileDrop.firstChild);
        }
        /* Remove button: stop the click from bubbling to the <label> (which
           would re-open the picker). Clear input + state. */
        previewWrap.querySelector('.ef-of__upload-preview__remove').addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          fileInput.value = '';
          fileInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      previewWrap.querySelector('.ef-of__upload-preview__img').src = dataUrl;
      previewWrap.style.display = '';
      if (fileIcon) fileIcon.style.display = 'none';
      if (fileHint) fileHint.textContent = 'Click to replace · ' + (fileName || 'photo');
      fileDrop.classList.add('has-file');
    }
    function hidePreview() {
      if (previewWrap) previewWrap.style.display = 'none';
      if (fileIcon) fileIcon.style.display = '';
      if (fileHint) fileHint.textContent = 'JPG, PNG up to 10MB';
      fileDrop.classList.remove('has-file');
    }

    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (f) {
        fileLabel.textContent = f.name;
        var reader = new FileReader();
        reader.onload = function (ev) { showPreview(ev.target.result, f.name); };
        reader.onerror = function () { /* Fallback — keep filename, no preview */
          showPreview('', f.name);
        };
        reader.readAsDataURL(f);
      } else {
        fileLabel.textContent = 'Drag a photo here or click to browse';
        hidePreview();
      }
    });
    if (fileDrop) {
      ['dragenter','dragover'].forEach(function(evt){
        fileDrop.addEventListener(evt, function(e){
          e.preventDefault(); e.stopPropagation();
          fileDrop.classList.add('is-dragover');
        });
      });
      ['dragleave','drop'].forEach(function(evt){
        fileDrop.addEventListener(evt, function(e){
          e.preventDefault(); e.stopPropagation();
          fileDrop.classList.remove('is-dragover');
        });
      });
      fileDrop.addEventListener('drop', function(e){
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(files[0]);
          fileInput.files = dt.files;
        } catch (err) {}
        fileInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  /* "Save or share configuration" — opens a modal with email field +
     copyable link. Worker endpoint sends the email; mailto: fallback
     if the worker is unreachable. URL hydration on the receiving end
     restores every selection so the customer can finish on any device. */
  function buildShareUrl() {
    var params = new URLSearchParams();
    Object.keys(state.selections || {}).forEach(function (g) {
      var s = state.selections[g];
      if (s && s.label) params.set(g, s.label);
    });
    if (state.sizeSel && state.sizeSel.label) params.set('size', state.sizeSel.label);
    if (widthInput && widthInput.value)  params.set('w', widthInput.value);
    if (heightInput && heightInput.value) params.set('h', heightInput.value);
    if (notesEl && notesEl.value) params.set('notes', notesEl.value.slice(0, 400));
    return location.origin + location.pathname + '?' + params.toString();
  }
  function buildShareSummary() {
    /* Plain-text summary used in the email body so the recipient sees
       the selections inline (not just a link). Mirrors the order-confirm
       lines in cfg v2's draft order worker. */
    var lines = [];
    if (widthInput && widthInput.value)  lines.push('Width: ' + widthInput.value + '"');
    if (heightInput && heightInput.value) lines.push('Height: ' + heightInput.value + '"');
    if (state.sizeSel && state.sizeSel.label) lines.push('Size: ' + state.sizeSel.label);
    Object.keys(state.selections || {}).forEach(function (g) {
      var s = state.selections[g];
      if (s && s.label) {
        var pretty = g.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        lines.push(pretty + ': ' + s.label + (s.price ? ' (+$' + s.price + ')' : ''));
      }
    });
    return lines.join('\n');
  }

  var shareLink = document.getElementById('efOfShareCfg');
  var shareModal = document.getElementById('efOfShareModal');
  if (shareLink && shareModal) {
    var shareEmail = document.getElementById('efOfShareEmail');
    var shareNote = document.getElementById('efOfShareNote');
    var shareLinkInput = document.getElementById('efOfShareLink');
    var shareCopyBtn = document.getElementById('efOfShareCopy');
    var shareSendBtn = document.getElementById('efOfShareSend');
    var shareMsg = document.getElementById('efOfShareMsg');
    var shareLastFocus = null;

    function shareSetMsg(text, kind) {
      if (!shareMsg) return;
      shareMsg.textContent = text;
      shareMsg.className = 'ef-of-share__msg ef-of-share__msg--' + (kind || 'ok');
      shareMsg.hidden = false;
    }
    function shareClearMsg() { if (shareMsg) shareMsg.hidden = true; }

    function shareOpen() {
      shareLastFocus = document.activeElement;
      var url = buildShareUrl();
      if (shareLinkInput) shareLinkInput.value = url;
      shareModal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      shareClearMsg();
      setTimeout(function () { if (shareEmail) shareEmail.focus(); }, 80);
    }
    function shareClose() {
      shareModal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (shareLastFocus && shareLastFocus.focus) try { shareLastFocus.focus(); } catch (e) {}
    }

    shareLink.addEventListener('click', function (e) { e.preventDefault(); shareOpen(); });
    shareModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-share-close]')) shareClose();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !shareModal.hasAttribute('hidden')) shareClose();
    });

    if (shareCopyBtn && shareLinkInput) {
      shareCopyBtn.addEventListener('click', function () {
        var url = shareLinkInput.value;
        var done = function () {
          shareCopyBtn.classList.add('is-copied');
          shareCopyBtn.querySelector('span').textContent = 'Copied ✓';
          setTimeout(function () {
            shareCopyBtn.classList.remove('is-copied');
            shareCopyBtn.querySelector('span').textContent = 'Copy';
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {
            shareLinkInput.select();
            try { document.execCommand('copy'); done(); } catch (e) {}
          });
        } else {
          shareLinkInput.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
        }
      });
    }

    if (shareSendBtn) {
      shareSendBtn.addEventListener('click', function () {
        var email = (shareEmail && shareEmail.value || '').trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          shareSetMsg('Please enter a valid email address.', 'err');
          if (shareEmail) shareEmail.focus();
          return;
        }
        var url = buildShareUrl();
        var summary = buildShareSummary();
        var note = (shareNote && shareNote.value || '').trim();

        shareSendBtn.disabled = true;
        var origText = shareSendBtn.textContent.trim();
        shareSendBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg> Sending…';

        /* Try the configurator-assistant worker first (auto-email path).
           If unreachable / no /share endpoint, fall back to opening the
           customer's mail client with mailto: prefilled — link still gets
           sent, just from their own outbox. */
        var workerUrl = 'https://configurator-assistant.danielzajacus.workers.dev/share-config';
        var payload = {
          email: email,
          product_handle: PRODUCT_HANDLE,
          product_title: (root.dataset.productTitle || ''),
          config_url: url,
          config_summary: summary,
          note: note
        };

        var sentOk = false;
        var to = setTimeout(function () { /* hard-cap 6s for worker */ if (!sentOk) fallbackMailto(); }, 6000);

        function fallbackMailto() {
          clearTimeout(to);
          if (sentOk) return;
          sentOk = true;
          var body = 'Here is my saved fireplace door configuration:\n\n'
                   + (note ? note + '\n\n' : '')
                   + summary + '\n\n'
                   + 'Resume on any device:\n' + url;
          var href = 'mailto:' + encodeURIComponent(email)
                   + '?subject=' + encodeURIComponent('My ExceptionalFire configuration')
                   + '&body=' + encodeURIComponent(body);
          window.location.href = href;
          shareSetMsg('Opening your email client to send the link to ' + email + '. Hit Send.', 'ok');
          shareSendBtn.disabled = false;
          shareSendBtn.textContent = origText;
        }

        fetch(workerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function (r) {
          if (!r.ok) throw new Error('worker ' + r.status);
          return r.json();
        })
        .then(function () {
          clearTimeout(to);
          sentOk = true;
          shareSetMsg('Sent! Check your inbox at ' + email + ' — your private link arrives in seconds.', 'ok');
          shareSendBtn.disabled = false;
          shareSendBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Sent ✓';
          setTimeout(shareClose, 2000);
        })
        .catch(function () {
          fallbackMailto();
        });
      });
    }
  }

  /* ── ATC submit ─────────────────────────────────────────────── */
  function msg(text, kind) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.className = 'ef-of__msg ef-of__msg--' + (kind || 'ok');
    msgEl.hidden = false;
  }

  function buildCartItems() {
    var configId = 'cfg-' + Date.now() + '-' + Math.floor(Math.random() * 100000);

    /* Properties that travel with the MAIN product line item.
       CRITICAL: do NOT include _parent_product on the main item.
       ef-cart-drawer.js:254 cleanOrphans() classifies items WITHOUT
       _parent_product as "main products" and tracks their _config_id.
       Items WITH _parent_product whose _config_id doesn't match any
       tracked main → marked as orphan and DELETED via /cart/update.js.
       If main has _parent_product, NOTHING is tracked as main, every
       line becomes an orphan, and the whole cart is wiped silently
       after add. cfg v2 (ef-configurator-v2.js:3382) only puts
       _parent_product on surcharges — same pattern here. */
    var properties = { _config_id: configId };
    if (widthInput.value)  properties['Width']  = widthInput.value + '"';
    if (heightInput.value) properties['Height'] = heightInput.value + '"';
    if (state.sizeSel) properties['Size'] = state.sizeSel.label;
    Object.keys(state.selections).forEach(function (k) {
      var s = state.selections[k];
      var key = k.replace(/_/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
      properties[key] = s.label;
    });
    if (notesEl && notesEl.value) properties['Notes'] = notesEl.value;

    /* ── NATIVE-VARIANT mode (gas logs) ─────────────────────────────────────
       Real Fyre sets encode Fuel × Ignition as native Shopify variants with the
       priced ignition ladder baked into each variant's price. Resolve the ONE
       variant matching the selected fuel + ignition and add only it — NO
       surcharge lines (the displayed total === the variant price). Falls through
       to legacy surcharge mode below if EF_GL data isn't present for this product. */
    var gl = window.EF_GL && window.EF_GL[root.dataset.productHandle];
    if (gl && gl.variants && gl.variants.length) {
      var match = resolveNativeVariant(gl);
      var nid = match ? parseInt(match.id, 10) : parseInt(BASE_VARIANT_ID, 10);
      if (!nid || isNaN(nid)) { console.error('[ef-orderform] gas-logs: could not resolve native variant.'); return []; }
      return [{ id: nid, quantity: 1, properties: properties }];
    }

    /* MAIN product line — ALWAYS the base product variant, never the
       size surcharge. cfg v2 line 3445: `var mainVid = variantId`. The
       previous code used state.sizeSel.variantId (the SIZE SURCHARGE
       variant) as main, which is why the cart silently stayed at 0
       items — Shopify accepted the POST but the surcharge variant has
       no inventory / is hidden / etc. */
    var mainId = parseInt(BASE_VARIANT_ID, 10);
    if (!mainId || isNaN(mainId)) {
      console.error('[ef-orderform] Missing BASE_VARIANT_ID — cannot ATC.');
      return [];
    }
    var items = [{ id: mainId, quantity: 1, properties: properties }];

    /* Size surcharge — added as a SEPARATE line (cfg v2 pattern). The
       variant comes from groupData.size[N].variantId (one of the 314
       hidden surcharge products keyed by tier). Skipped if size has
       no surcharge (e.g. base tier with $0 included price). */
    if (state.sizeSel && state.sizeSel.variantId && state.sizeSel.price > 0) {
      items.push({
        id: parseInt(state.sizeSel.variantId, 10),
        quantity: 1,
        properties: {
          _parent_product: (root.dataset.productTitle || PRODUCT_HANDLE),
          _option_type: 'Size',
          _config_id: configId
        }
      });
    }

    /* Per-option surcharges — finish/glass/mesh/draft/etc. Match cfg v2
       filter: only push when variantId exists AND price > 0 (free
       options like default Matte Black don't need a surcharge line). */
    Object.keys(state.selections).forEach(function (k) {
      var s = state.selections[k];
      if (!s || !s.variantId) return;
      var vid = parseInt(s.variantId, 10);
      if (!vid || isNaN(vid)) return;
      if (!s.price || s.price <= 0) return;
      items.push({
        id: vid,
        quantity: 1,
        properties: {
          _parent_product: (root.dataset.productTitle || PRODUCT_HANDLE),
          _option_type: k.replace(/_/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); }),
          _config_id: configId
        }
      });
    });
    return items;
  }

  function validate() {
    /* Gas-logs: firebox dimensions are optional (no size-tier step consumes them
       yet). Doors keep them required via the EF_GL absence check. */
    var nativeMode = !!(window.EF_GL && window.EF_GL[root.dataset.productHandle]);
    if (!nativeMode && (!widthInput.value || !heightInput.value)) {
      msg('Please enter both width and height.', 'err');
      widthInput.focus(); return false;
    }
    var missing = [];
    details.forEach(function (d) {
      if (d.dataset.required === 'true' && d.dataset.selected !== 'true') {
        var legend = d.closest('.ef-of__field').querySelector('.ef-of__legend');
        missing.push(legend ? legend.textContent.replace(/^\s*\d+\s*/, '').trim() : d.dataset.group);
      }
    });
    if (missing.length) {
      msg('Please complete: ' + missing.join(', '), 'err');
      return false;
    }
    return true;
  }

  /* ATC handler — bind directly to button click (not form submit) so we
     don't depend on the form lifecycle. Mirrors ef-configurator-v2.js
     line 3365: disabled check → spinner → build payload → fetch
     /cart/add.js → open cart drawer or redirect to /cart. */
  if (atcBtn) {
    /* Prevent the native form submit since the button is type=submit
       inside <form> — without this both the native POST and our fetch
       would fire, causing a flash of the cart page. */
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });

    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (atcBtn.disabled) return;

      if (!validate()) {
        /* Scroll the error msg into view so the user knows what's blocking. */
        if (msgEl && !msgEl.hidden) {
          try { msgEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e2) {}
        }
        return;
      }

      var labelEl = atcBtn.querySelector('.ef-of__atc-label');
      var origLabel = labelEl ? labelEl.textContent : 'Add to Cart';
      atcBtn.disabled = true;
      if (labelEl) labelEl.textContent = 'Adding…';

      var items = buildCartItems();

      /* DEBUG payload — same instrumentation as cfg v2 so we can verify
         variantIDs in DevTools when surcharges look off. */
      try {
        console.group('[ef-orderform] Add to Cart payload');
        console.log('Selections:', JSON.parse(JSON.stringify(state.selections)));
        console.log('Width/Height:', widthInput && widthInput.value, heightInput && heightInput.value);
        console.log('Items:');
        items.forEach(function (it, i) {
          console.log('  [' + i + '] variantId=' + it.id + ' qty=' + it.quantity, it.properties);
        });
        console.groupEnd();
      } catch (e2) {}

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) {
        return r.text().then(function (raw) {
          var json;
          try { json = JSON.parse(raw); } catch (e) { json = { raw: raw }; }
          if (!r.ok) {
            console.error('[ef-orderform] Cart reject:', r.status, json);
            throw new Error(json.description || json.message || ('Cart error ' + r.status));
          }
          console.log('[ef-orderform] /cart/add.js response:', json);
          return json;
        });
      })
      .then(function (addRes) {
        /* Verify items actually landed by fetching /cart.js. If qty is 0
           after the add, surface the error to the user rather than show
           "Added ✓" → empty drawer (the previous silent failure mode). */
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            console.log('[ef-orderform] /cart.js after add:', cart);
            if (!cart || !cart.item_count || cart.item_count === 0) {
              throw new Error('Cart shows 0 items after add — variant rejected or out of stock.');
            }
            return cart;
          });
      })
      .then(function (cart) {
        if (labelEl) labelEl.textContent = 'Added ✓';
        atcBtn.style.background = '#1F7A3A';
        msg('Added to cart!', 'ok');
        /* Tell any listeners (cart drawer, badge, sticky bar) to re-read. */
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart })); } catch (e) {}
        try { window.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart })); } catch (e) {}
        setTimeout(function () {
          if (window.EFCartDrawer && window.EFCartDrawer.open) {
            window.EFCartDrawer.open();
          } else {
            window.location.href = '/cart';
          }
          /* Restore button so a second add still works after drawer closes. */
          setTimeout(function () {
            atcBtn.disabled = false;
            atcBtn.style.background = '';
            if (labelEl) labelEl.textContent = origLabel;
          }, 1200);
        }, 700);
      })
      .catch(function (err) {
        console.error('[ef-orderform] ATC failed:', err);
        msg('Could not add: ' + err.message + '. Try again or call (949) 619-7824.', 'err');
        atcBtn.disabled = false;
        atcBtn.style.background = '';
        if (labelEl) labelEl.textContent = origLabel;
        try { msgEl && msgEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e2) {}
      });
    });
  }

  /* ── Express Checkout — same pattern as ef-configurator-v2.js
     "buy with wallet" handler. Validates → POST /cart/add.js → redirect
     to /checkout (wallets like Shop Pay/Apple Pay/Google Pay appear at
     the top there as Express options based on buyer browser). ── */
  var expressBtn = document.getElementById('efOfExpressCheckout');
  if (expressBtn) {
    expressBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!validate()) return;
      expressBtn.disabled = true;
      var origLabel = expressBtn.querySelector('span').textContent;
      expressBtn.querySelector('span').textContent = 'Starting checkout…';
      var items = buildCartItems();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items }),
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Cart error ' + r.status); });
        return r.json();
      }).then(function () {
        /* Hard redirect — Shopify checkout shows Shop Pay / Apple Pay /
           Google Pay express buttons at the top automatically. */
        window.location.href = '/checkout';
      }).catch(function (err) {
        console.error('[ef-orderform] Express Checkout error:', err);
        msg('Could not start checkout: ' + err.message + '. Please use Add to Cart.', 'err');
        expressBtn.disabled = false;
        expressBtn.querySelector('span').textContent = origLabel;
      });
    });
  }

  /* ── AI photo flow — same worker as configurator v2 (configurator-assistant).
     Click CTA → expand inline panel. Pick file → HEIC convert if needed →
     resize to 1600px JPEG → POST to worker → render specs + auto-pick
     matching dropdowns when AI returns confident matches. ───────────────── */
  (function initAi() {
    var aiBtn = document.getElementById('efOfAiBtn');
    var aiPanel = document.getElementById('efOfAiPanel');
    var aiUpload = document.getElementById('efOfAiUpload');
    var aiFile = document.getElementById('efOfAiFile');
    var aiAnalyzing = document.getElementById('efOfAiAnalyzing');
    var aiResult = document.getElementById('efOfAiResult');
    var aiPreview = document.getElementById('efOfAiPreview');
    var aiStatus = document.getElementById('efOfAiStatus');
    var aiSpecs = document.getElementById('efOfAiSpecs');
    if (!aiBtn || !aiPanel) return;

    var WORKER_URL = 'https://configurator-assistant.danielzajacus.workers.dev';

    /* Toggle panel on CTA click */
    aiBtn.addEventListener('click', function () {
      var open = aiPanel.style.display !== 'none';
      aiPanel.style.display = open ? 'none' : 'block';
      if (!open) aiBtn.style.display = 'none';
    });

    /* HEIC support — lazy-load converter only when iPhone HEIC photo is uploaded */
    var heic2anyLoaded = null;
    function loadHeic2Any() {
      if (heic2anyLoaded) return heic2anyLoaded;
      heic2anyLoaded = new Promise(function (resolve, reject) {
        if (window.heic2any) return resolve(window.heic2any);
        var s = document.createElement('script');
        s.src = window.EF_HEIC2ANY_URL || 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js';
        var loadedFlag = false;
        var timeoutId = setTimeout(function () {
          if (loadedFlag) return;
          reject(new Error('HEIC converter failed to load (network timeout). Please switch to WiFi and try again, or re-export your photo as JPEG.'));
        }, 15000);
        s.onload = function () { loadedFlag = true; clearTimeout(timeoutId); resolve(window.heic2any); };
        s.onerror = function () { clearTimeout(timeoutId); reject(new Error('Failed to load HEIC converter (CDN blocked). Please re-export your photo as JPEG.')); };
        document.head.appendChild(s);
      });
      return heic2anyLoaded;
    }
    function isHeic(file) {
      var name = (file.name || '').toLowerCase();
      var type = (file.type || '').toLowerCase();
      return type === 'image/heic' || type === 'image/heif' || /\.(heic|heif)$/i.test(name);
    }
    function probeNativeHeic(file) {
      return new Promise(function (resolve) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        var settled = false;
        function done(ok) { if (settled) return; settled = true; URL.revokeObjectURL(url); resolve(ok); }
        img.onload = function () { done(img.naturalWidth > 0); };
        img.onerror = function () { done(false); };
        setTimeout(function () { done(false); }, 4000);
        img.src = url;
      });
    }
    /* Safari/iOS decode HEIC natively in <img> — no wasm needed there; downstream canvas re-encode outputs JPEG. */
    function convertHeicToJpeg(file) {
      return probeNativeHeic(file).then(function (nativeOk) {
        if (nativeOk) return file;
        return wasmConvertHeic(file);
      });
    }
    var efHeifLoaded = null;
    function loadEfHeif() {
      if (efHeifLoaded) return efHeifLoaded;
      efHeifLoaded = new Promise(function (resolve, reject) {
        if (window.EFConvertHeic) return resolve();
        if (!window.EF_HEIF_URL) return reject(new Error('no EF_HEIF_URL'));
        var s = document.createElement('script');
        s.src = window.EF_HEIF_URL;
        var t = setTimeout(function () { reject(new Error('ef-heic load timeout')); }, 20000);
        s.onload = function () { clearTimeout(t); window.EFConvertHeic ? resolve() : reject(new Error('ef-heic loaded but no API')); };
        s.onerror = function () { clearTimeout(t); reject(new Error('ef-heic failed to load')); };
        document.head.appendChild(s);
      });
      return efHeifLoaded;
    }
    /* Decoder ladder: modern libheif first (handles iPhone 15/16 HDR HEIC), legacy heic2any as fallback. */
    function wasmConvertHeic(file) {
      return loadEfHeif().then(function () { return window.EFConvertHeic(file); })
        .catch(function (err) { if (window.console) console.warn('[ef-heic] libheif path failed, trying heic2any:', err && err.message); return legacyConvertHeic(file); });
    }
    function legacyConvertHeic(file) {
      return loadHeic2Any().then(function (h) {
        return h({ blob: file, toType: 'image/jpeg', quality: 0.9 });
      }).then(function (blob) {
        if (Array.isArray(blob)) blob = blob[0];
        return new File([blob], (file.name || 'photo').replace(/\.(heic|heif)$/i, '.jpg'), { type: 'image/jpeg' });
      });
    }

    /* Resize to max 1600px JPEG (q=0.85) — keeps under Anthropic 5MB limit */
    function resizeImage(file, maxDim) {
      return new Promise(function (resolve, reject) {
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          var w = img.naturalWidth, h = img.naturalHeight;
          if (w > maxDim || h > maxDim) {
            var ratio = Math.min(maxDim / w, maxDim / h);
            w = Math.round(w * ratio);
            h = Math.round(h * ratio);
          }
          var canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          URL.revokeObjectURL(url);
          resolve(canvas.toDataURL('image/jpeg', 0.85));
        };
        img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('Image decode failed')); };
        img.src = url;
      });
    }

    /* Auto-pick a dropdown option whose label matches a given keyword
       (case-insensitive substring match against opt.dataset.label). */
    function autoPickByKeyword(group, keyword) {
      if (!keyword) return;
      var detailsEl = root.querySelector('.ef-of__cd[data-group="' + group + '"]');
      if (!detailsEl) return;
      var opts = detailsEl.querySelectorAll('.ef-of__cd-opt');
      for (var i = 0; i < opts.length; i++) {
        var lbl = (opts[i].dataset.label || '').toLowerCase();
        if (lbl.indexOf(keyword.toLowerCase()) !== -1) {
          onOptClick({ target: opts[i], currentTarget: opts[i] });
          detailsEl.open = false;
          return true;
        }
      }
      return false;
    }

    /* Spec card — renders as a 2-col grid item with bronze label + bold value
       (mirror cfg v2 .ef-cfg-ai-panel__spec). */
    function aiSpec(label, value) {
      return '<div class="ef-cfg-ai-panel__spec">'
        + '<div class="ef-cfg-ai-panel__spec-label">' + escapeHtml(label) + '</div>'
        + '<div class="ef-cfg-ai-panel__spec-val">' + escapeHtml(String(value)) + '</div></div>';
    }

    /* Render the AI Measuring Guide card under Width/Height inputs.
       2026-05-13 — switched from per-photo AI tips (inconsistent) to STATIC
       general rules per fireplace type. AI is only used to detect masonry vs
       prefab; the rules themselves are hardcoded so they cannot drift. */
    function renderAiPrefill(data) {
      var box = document.getElementById('efOfAiPrefill');
      if (!box) return;
      if (!data.estimated_width || !data.estimated_height) {
        box.hidden = true; box.innerHTML = '';
        return;
      }
      var fpType = (data.fireplace_type || '').toLowerCase();
      var isMasonry = fpType.indexOf('masonry') !== -1;
      var typeLabel = isMasonry ? 'Masonry Fireplace' : 'Prefab / Zero-Clearance Fireplace';

      var rules = isMasonry
        ? [
            'Measure WIDTH at three points (top, middle, bottom) — use the SMALLEST width.',
            'Measure HEIGHT at three points (left, center, right) — use the SMALLEST height.',
            'Measure brick-to-brick or stone-to-stone at the FRONT opening — not deep inside the firebox.',
            'If a lintel bar is FLUSH with the front face: measure HEIGHT to the BOTTOM of the lintel — the door frame will seat against it.',
            'If a lintel bar is RECESSED (more than ~1" behind the front face): IGNORE it — measure height to the top of the brick/stone opening.',
            'Measure to the nearest 1/8".'
          ]
        : [
            'Measure the FRONT METAL OPENING — where the new door frame will install. Not deep inside the firebox.',
            'Measure WIDTH (left edge of metal to right edge) at top, middle, and bottom — use the SMALLEST width.',
            'Measure HEIGHT (front bottom to front top of metal opening) at left, center, and right — use the SMALLEST height.',
            'DO NOT measure: the back wall, behind logs / grate / mesh curtain / vents / louvers, or anywhere deep inside the firebox.',
            'There is NO structural lintel bar on a prefab. Any horizontal metal element you see deep inside is a smoke shelf or panel brace — NOT a measurement landmark.',
            'If old factory doors / metal trim are still installed: REMOVE them first, then measure the clean front opening.',
            'If the surround (tile / marble / stone) is rough or uneven, the frame may not seat flush — install the frame first, then bring veneer up to its edge.',
            'Measure to the nearest 1/8".'
          ];

      var html = '<div class="ef-of__ai-prefill__head">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>'
        + '<span class="ef-of__ai-prefill__title">' + escapeHtml(typeLabel) + ' &mdash; Measuring Guide</span>'
        + '<span class="ef-of__ai-prefill__badge">EST. ' + escapeHtml(String(data.estimated_width)) + '" &times; ' + escapeHtml(String(data.estimated_height)) + '"</span></div>';
      html += '<p class="ef-of__ai-prefill__lede">General measurement rules for your fireplace type. <strong>Always use a tape measure</strong> and enter the exact width and height above.</p>';
      html += '<ul class="ef-of__ai-prefill__tips">';
      rules.forEach(function (t) {
        html += '<li><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg><span>' + t + '</span></li>';
      });
      html += '</ul>';

      /* Fit type analyzed callout */
      if (data.recommended_fit) {
        html += '<div class="ef-of__ai-prefill__tip ef-of__ai-prefill__tip--ok"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" stroke-width="2.4"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>'
          + '<div><strong>Fit Type analyzed</strong> &mdash; see Overlap/Inside Fit cards in Step 4 for product-specific tolerance and measuring tips.</div></div>';
      }
      /* Premium 2-button CTA — phone (primary filled) + Calendly (secondary outline). */
      html += '<div class="ef-of__ai-help">'
        + '<div class="ef-of__ai-help__head">'
        + '<p class="ef-of__ai-help__title">Not sure what to measure?</p>'
        + '<p class="ef-of__ai-help__sub">Talk to a fireplace specialist &mdash; free, no commitment.</p>'
        + '</div>'
        + '<div class="ef-of__ai-help__actions">'
        + '<a href="tel:+19496197824" class="ef-of__ai-help__btn ef-of__ai-help__btn--primary">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>'
        + '<span>(949) 619-7824</span>'
        + '</a>'
        + '<a href="" onclick="Calendly &amp;&amp; Calendly.initPopupWidget({url:\'https://calendly.com/exceptionalfire/expert-consultation\'}); return false;" class="ef-of__ai-help__btn ef-of__ai-help__btn--secondary">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>'
        + '<span>Book a 15-min call</span>'
        + '</a>'
        + '</div></div>';
      box.innerHTML = html;
      box.hidden = false;
    }

    /* Render AI recommendation tip boxes — one per group where worker returned
       a recommendation + reasoning. Tip is prepended INSIDE the <details> body
       (above the option grid) so user sees AI advice when expanding. Format
       matches cfg v2: "AI Expert recommends [Value] — [Reasoning]". Also sets
       aria-airec="true" on the matching card so a gold pill badge renders. */
    function renderAiRecs(data) {
      /* Persist for later re-renders (door_type → mesh re-render wipes the tip). */
      state.aiData = data;
      var recs = [
        { group: 'fit_type',      value: data.recommended_fit,    reason: data.fit_reason },
        { group: 'finish',        value: data.recommended_finish, reason: data.finish_reason },
        { group: 'glass',         value: data.recommended_glass,  reason: data.glass_reason },
        { group: 'mesh',          value: data.recommended_mesh || '', reason: data.mesh_reason },
        { group: 'draft_control', value: data.recommended_draft || '', reason: data.draft_reason }
      ];
      recs.forEach(function (r) { applyOneRec(r); });
    }

    /* Apply one recommendation to its dropdown — renders/re-renders tip box +
       sets badge on matching card. Safe to call multiple times. */
    function applyOneRec(r) {
      if (!r.reason && !r.value) return;
      var detailsEl = root.querySelector('.ef-of__cd[data-group="' + r.group + '"]');
      if (!detailsEl) return;

      /* Remove any prior badge */
      detailsEl.querySelectorAll('.ef-of__cd-opt').forEach(function (c) {
        c.removeAttribute('data-airec');
        var oldBadge = c.querySelector('.ef-of__airec-badge');
        if (oldBadge) oldBadge.remove();
      });
      /* Add gold "★ AI RECOMMENDED" pill on matching card */
      if (r.value) {
        var opts = detailsEl.querySelectorAll('.ef-of__cd-opt');
        for (var i = 0; i < opts.length; i++) {
          var lbl = (opts[i].dataset.label || '').toLowerCase();
          if (lbl.indexOf(r.value.toLowerCase()) !== -1) {
            opts[i].setAttribute('data-airec', 'true');
            var badge = document.createElement('span');
            badge.className = 'ef-of__airec-badge';
            badge.innerHTML = '<svg width="11" height="11" viewBox="0 0 20 20" fill="currentColor"><path d="M10 1l2.47 5.01L18 6.94l-4 3.9.94 5.51L10 13.77l-4.94 2.58L6 10.84l-4-3.9 5.53-.93z"/></svg> AI RECOMMENDED';
            opts[i].appendChild(badge);
            break;
          }
        }
      }

      /* Replace tip box at top of list */
      var prev = detailsEl.querySelector('.ef-of__ai-rec');
      if (prev) prev.remove();
      var tip = document.createElement('div');
      tip.className = 'ef-of__ai-rec';
      var head = '<div class="ef-of__ai-rec__head"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0F6E56" stroke-width="2.4"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>';
      head += '<strong>AI Expert recommends';
      if (r.value) head += ' ' + escapeHtml(r.value);
      head += '</strong></div>';
      var body = r.reason ? '<p>' + escapeHtml(r.reason) + '</p>' : '';
      tip.innerHTML = head + body;
      var list = detailsEl.querySelector('.ef-of__cd-list');
      if (list) list.insertBefore(tip, list.firstChild);
    }

    /* Re-apply all stored AI recs after a dropdown re-render (e.g., mesh
       re-renders when door_type changes — the tip+badge get wiped). */
    function reapplyAiRecsForGroup(group) {
      if (!state.aiData) return;
      var d = state.aiData;
      var map = {
        fit_type:      { value: d.recommended_fit,    reason: d.fit_reason },
        finish:        { value: d.recommended_finish, reason: d.finish_reason },
        glass:         { value: d.recommended_glass,  reason: d.glass_reason },
        mesh:          { value: d.recommended_mesh || '', reason: d.mesh_reason },
        draft_control: { value: d.recommended_draft || '', reason: d.draft_reason }
      };
      if (map[group]) applyOneRec({ group: group, value: map[group].value, reason: map[group].reason });
    }

    /* Lintel note inside AI result panel */
    function renderLintelNote(data) {
      var note = document.getElementById('efOfAiLintelNote');
      if (!note) return;
      if (!(data.lintel_bar && data.lintel_bar.visible)) {
        note.style.display = 'none'; note.innerHTML = '';
        return;
      }
      var pos = data.lintel_bar.position;
      var posExpl = pos === 'flush'
        ? '<strong>Flush</strong> means the bar sits even with the brick face — measure height to the bottom of the bar, the door frame will cover it.'
        : pos === 'recessed'
        ? '<strong>Recessed</strong> means the bar is set back inside the opening — measure height to the top of the brick/stone, NOT to the bar deep inside.'
        : 'Measure carefully at the top of the opening — see tips below for guidance.';
      note.innerHTML =
        '<div style="display:flex;gap:8px;align-items:flex-start;padding:10px 12px;background:#FEF8EE;border:1px solid #F2E5C8;border-radius:6px;margin-top:10px;">'
        + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8A6A43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>'
        + '<div style="font-family:Inter,sans-serif;font-size:12.5px;line-height:1.5;color:#3A3732;">'
        + '<p style="margin:0 0 4px;"><strong style="color:#1E1E1B;font-weight:600;">What is a lintel bar?</strong> A horizontal metal bar (usually steel angle iron) at the top of masonry fireplace openings — it supports the brickwork above. Often painted to match the brick.</p>'
        + '<p style="margin:0;color:#5C5852;">' + posExpl + '</p>'
        + '</div></div>';
      note.style.display = 'block';
    }

    /* Drag-and-drop support for the new dashed drop-zone — visual hover
       state + accept the drop into the file input so the change handler
       below picks it up. Touch/click still work via the <label>. */
    if (aiUpload) {
      ['dragenter','dragover'].forEach(function(evt){
        aiUpload.addEventListener(evt, function(e){
          e.preventDefault(); e.stopPropagation();
          aiUpload.classList.add('is-dragover');
        });
      });
      ['dragleave','drop'].forEach(function(evt){
        aiUpload.addEventListener(evt, function(e){
          e.preventDefault(); e.stopPropagation();
          aiUpload.classList.remove('is-dragover');
        });
      });
      aiUpload.addEventListener('drop', function(e){
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(files[0]);
          aiFile.files = dt.files;
        } catch (err) {
          /* Older browsers — fall back to dispatching a manual change with
             the dropped file held on the input.dataset for the handler to
             pick up via globalThis. */
        }
        aiFile.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* File picked → analyze. POST body keys + response parsing match cfg v2
       worker contract 1:1 (image, product_handle, cfg_group → fireplace_type,
       firebox_type, estimated_width/height, lintel_bar, confidence). */
    aiFile.addEventListener('change', function (e) {
      var file = e.target.files[0];
      if (!file) return;

      aiUpload.style.display = 'none';
      aiAnalyzing.style.display = 'block';
      aiResult.style.display = 'none';

      var processFile;
      if (isHeic(file)) {
        if (aiStatus) aiStatus.textContent = 'Converting iPhone photo (HEIC → JPEG)…';
        processFile = convertHeicToJpeg(file);
      } else {
        processFile = Promise.resolve(file);
      }

      var msgTimer = null;
      var elapsedTimer = null;

      processFile.then(function (finalFile) {
        if (aiStatus) aiStatus.textContent = 'Preparing image…';
        return resizeImage(finalFile, 1600);
      }).then(function (dataUrl) {
        if (aiPreview) aiPreview.src = dataUrl;

        /* Rotate status messages — paced for typical 30-50s analysis (5.5s interval). */
        var msgs = [
          'Uploading and processing your photo…',
          'Identifying fireplace type — masonry or prefab',
          'Detecting opening shape and hearth',
          'Checking lintel bar, louvers, and surround',
          'Estimating dimensions from visual references',
          'Matching against door catalog',
          'Preparing recommendations…'
        ];
        var msgIdx = 0;
        if (aiStatus) aiStatus.textContent = msgs[0];
        msgTimer = setInterval(function () {
          msgIdx++;
          if (msgIdx < msgs.length && aiStatus) {
            aiStatus.style.opacity = '0';
            setTimeout(function () {
              aiStatus.textContent = msgs[msgIdx];
              aiStatus.style.opacity = '1';
            }, 200);
          }
        }, 5500);

        /* Live elapsed timer (m:ss format). */
        var elapsedStart = Date.now();
        var elapsedEl = document.getElementById('efOfAiElapsed');
        elapsedTimer = setInterval(function () {
          if (!elapsedEl) return;
          var s = Math.floor((Date.now() - elapsedStart) / 1000);
          var m = Math.floor(s / 60);
          var ss = s % 60;
          elapsedEl.textContent = m + ':' + (ss < 10 ? '0' + ss : ss);
        }, 1000);

        return fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            image: dataUrl,
            product_handle: PRODUCT_HANDLE,
            cfg_group: CFG_GROUP || null
          })
        });
      }).then(function (r) { return r.json(); }).then(function (data) {
        clearInterval(msgTimer); msgTimer = null;
        clearInterval(elapsedTimer); elapsedTimer = null;
        console.log('[ef-orderform AI] Worker response:', data);

        /* Empty fireplace_type or explicit error → reset to upload state */
        if (data.error || !data.fireplace_type) {
          aiAnalyzing.style.display = 'none';
          aiUpload.style.display = 'flex';
          aiBtn.style.display = 'flex';
          aiPanel.style.display = 'none';
          var msg = data.overloaded
            ? 'Our AI service is briefly overloaded. Please try again in 30 seconds, or pick manually below.'
            : 'Could not analyze this photo. Please try a different photo or pick manually below.';
          alert(msg);
          return;
        }

        aiAnalyzing.style.display = 'none';
        aiResult.style.display = 'block';

        /* Build specs display (mirror cfg v2). */
        var fpType = (data.fireplace_type || '').toLowerCase().indexOf('masonry') !== -1 ? 'Masonry' : 'Factory-Built';
        var fbType = (data.firebox_type || '').toLowerCase().indexOf('flush') !== -1 ? 'Flush Hearth' : 'Hole in Wall';
        var html = '';
        html += aiSpec('Type', fpType);
        html += aiSpec('Firebox', fbType);
        if (data.estimated_width && data.estimated_height) {
          html += aiSpec('Est. Size', data.estimated_width + '" x ' + data.estimated_height + '"');
        }
        if (data.lintel_bar && data.lintel_bar.visible) {
          var pos = data.lintel_bar.position;
          html += aiSpec('Lintel Bar', pos === 'flush' ? 'Flush' : (pos === 'recessed' ? 'Recessed' : 'Detected'));
        }
        html += aiSpec('Confidence', (data.confidence || 85) + '%');
        if (aiSpecs) aiSpecs.innerHTML = html;

        /* Lintel note inside the AI result block (cream tip card). */
        renderLintelNote(data);

        /* Auto-pick dropdowns ONLY — width/height stay empty so the customer
           is forced to measure and enter exact dimensions. AI estimates are
           shown above (Est. Size spec + warn notice) but never written into
           the inputs. Reason: per customer feedback, prefilled estimates were
           being submitted without verification, causing fit issues. */
        autoPickByKeyword('fireplace_type', fpType);
        autoPickByKeyword('firebox_type', fbType);
        if (data.recommended_fit) autoPickByKeyword('fit_type', data.recommended_fit);

        /* AI Pre-filled tips card under W/H — only when worker returned dimensions. */
        renderAiPrefill(data);

        /* Render AI recommendation tips at fit_type / finish / glass / mesh / draft_control
           dropdowns (mirror cfg v2 renderAiTips). Each tip has the worker's
           reasoning copy + a green Fit-Advice border. */
        renderAiRecs(data);
      }).catch(function (err) {
        clearInterval(msgTimer);
        clearInterval(elapsedTimer);
        console.error('[ef-orderform AI]', err);
        aiAnalyzing.style.display = 'none';
        aiUpload.style.display = '';
        msg('AI analysis failed: ' + err.message + '. Please fill the form manually or call (949) 619-7824.', 'err');
      });
    });
  })();

  /* Init */
  if (widthInput) widthInput.addEventListener('input', onDimChange);
  if (heightInput) heightInput.addEventListener('input', onDimChange);

  /* ── Hydrate from URL params ─────────────────────────────────
     Lets a customer come back to a saved configuration via the
     "Save or share configuration" link. Reads ?w=&h=&finish=...
     and re-applies each selection by simulating clicks on the
     matching option cards. Width/Height are written direct + size
     match recomputes. Runs AFTER populateAll's preselect pass
     so it overrides defaults. */
  function hydrateFromUrl() {
    var sp;
    try { sp = new URLSearchParams(location.search); } catch (e) { return; }
    if (!sp || sp.toString() === '') return;

    var w = sp.get('w');
    var h = sp.get('h');
    if (w && widthInput) widthInput.value = w;
    if (h && heightInput) heightInput.value = h;
    if ((w || h) && (typeof onDimChange === 'function')) onDimChange();

    /* For every dropdown, look for a query param matching its group
       name and click the option whose dataset.label matches. */
    details.forEach(function (d) {
      var g = d.dataset.group;
      var want = sp.get(g);
      if (!want) return;
      var opts = d.querySelectorAll('.ef-of__cd-opt');
      var lc = want.toLowerCase();
      for (var i = 0; i < opts.length; i++) {
        if ((opts[i].dataset.label || '').toLowerCase() === lc) {
          onOptClick({ target: opts[i], currentTarget: opts[i] });
          break;
        }
      }
    });

    /* Notes textarea — restore typed message if shared. */
    var notesParam = sp.get('notes');
    if (notesParam && notesEl) notesEl.value = notesParam;

    /* Inline confirmation msg so the user knows the form was restored. */
    if (msgEl) msg('Configuration restored from your saved link.', 'ok');
  }

  whenDataReady(function (loaded) {
    if (!loaded) {
      msg('Loading is slow. Refresh or call (949) 619-7824.', 'err');
      return;
    }
    populateAll();
    /* Hydrate AFTER populateAll so URL params override default preselects. */
    hydrateFromUrl();
    recomputeTotal();
  });
})();

/* ════════════════════════════════════════════════════════════════
   FINISH SAMPLES MODAL — popup triggered by "Order Finish Samples →"
   under the finish dropdown. Mirrors ef-configurator-v2.js
   renderSamples() (line ~1315) 1:1: builds a swatch grid from the
   product's finish options, multi-select, ATC pushes one $10 line
   item per selected swatch. Variant ID matches cfg v2.
   ════════════════════════════════════════════════════════════════ */
(function efOfSamplesModalInit() {
  var DOOR_SAMPLE_VARIANT_ID = '42380268535890';
  var SAMPLE_PRICE = 10;

  function init() {
    var openBtn = document.getElementById('efOfSamplesOpen');
    var modal   = document.getElementById('efOfSamplesModal');
    if (!openBtn || !modal) return;

    var grid    = document.getElementById('efOfSamplesGrid');
    var countEl = document.getElementById('efOfSamplesCount');
    var totalEl = document.getElementById('efOfSamplesTotal');
    var atcBtn  = document.getElementById('efOfSamplesAtc');
    var rendered = false;
    var selected = {};
    var lastFocus = null;

    function escAttr(s) { return String(s || '').replace(/"/g, '&quot;'); }
    function escHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
      });
    }

    function renderGrid() {
      if (rendered) return;
      /* Pull finish options from EF_CFG_DATA via the same lookup the
         dropdowns use. window.EF_OF_FIND_GROUP is exposed by the main
         IIFE for this purpose. */
      var groupData = (typeof window.EF_OF_FIND_GROUP === 'function') ? window.EF_OF_FIND_GROUP() : null;
      if (!groupData || !groupData.finish || !groupData.finish.length) {
        grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;padding:24px;color:#8A8579;font-size:13px;">No finishes available right now. Please refresh or call (949) 619-7824.</p>';
        rendered = true;
        return;
      }
      grid.innerHTML = groupData.finish.map(function (f) {
        var bg = f.img ? 'background-image:url(' + String(f.img).replace(/ /g, '%20') + ');' : 'background-color:#888;';
        var lbl = f.label || '';
        return '<button type="button" class="ef-of-samples-card" data-label="' + escAttr(lbl) + '" data-img="' + escAttr(f.img || '') + '" aria-pressed="false">'
             +   '<span class="ef-of-samples-card__swatch" style="' + bg + '"></span>'
             +   '<span class="ef-of-samples-card__name">' + escHtml(lbl) + '</span>'
             + '</button>';
      }).join('');
      rendered = true;
    }

    function updateBar() {
      var n = Object.keys(selected).length;
      if (n === 0) {
        countEl.textContent = '0 selected';
        totalEl.textContent = '$0';
      } else {
        countEl.textContent = n + ' selected';
        totalEl.textContent = '$' + (n * SAMPLE_PRICE).toLocaleString('en-US');
      }
    }

    function open() {
      lastFocus = document.activeElement;
      renderGrid();
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var firstCard = grid.querySelector('.ef-of-samples-card');
        if (firstCard) firstCard.focus();
      }, 80);
    }
    function close() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    }

    openBtn.addEventListener('click', open);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-samples-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
    });

    /* Toggle select on swatch click */
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.ef-of-samples-card');
      if (!card) return;
      var label = card.dataset.label;
      if (selected[label]) {
        delete selected[label];
        card.classList.remove('is-selected');
        card.setAttribute('aria-pressed', 'false');
      } else {
        selected[label] = { label: label, img: card.dataset.img || '' };
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
      }
      updateBar();
    });

    var atcDefault = atcBtn.innerHTML;
    atcBtn.addEventListener('click', function () {
      var labels = Object.keys(selected);
      if (!labels.length) {
        countEl.style.color = '#8A6A43';
        countEl.style.fontWeight = '700';
        countEl.textContent = 'Tap a swatch above to add';
        setTimeout(function () {
          countEl.style.color = '';
          countEl.style.fontWeight = '';
          updateBar();
        }, 1800);
        return;
      }
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      var setId = 'sample-' + Date.now().toString(36);
      var items = labels.map(function (n) {
        var props = { 'Finish': n, '_sample_set_id': setId };
        if (selected[n] && selected[n].img) props._finish_image = selected[n].img;
        return { id: parseInt(DOOR_SAMPLE_VARIANT_ID, 10), quantity: 1, properties: props };
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) { if (!r.ok) throw new Error('cart error'); return r.json(); })
      .then(function () {
        atcBtn.style.background = '#1F7A3A';
        atcBtn.innerHTML = 'Added &#10003;';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (window.EFCartDrawer && typeof window.EFCartDrawer.open === 'function') {
          window.EFCartDrawer.open();
        }
        setTimeout(function () {
          atcBtn.disabled = false;
          atcBtn.style.background = '';
          atcBtn.innerHTML = atcDefault;
          /* Reset selections so the modal is clean on next open. */
          selected = {};
          grid.querySelectorAll('.ef-of-samples-card.is-selected').forEach(function (c) {
            c.classList.remove('is-selected');
            c.setAttribute('aria-pressed', 'false');
          });
          updateBar();
          close();
        }, 1100);
      })
      .catch(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Error — try again';
        setTimeout(function () { atcBtn.innerHTML = atcDefault; }, 2000);
      });
    });

    updateBar();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ════════════════════════════════════════════════════════════════
   How-to-Measure tab switcher — Masonry / Prefab / Arch.
   Tiny vanilla IIFE: click a tab → activate it + show its panel,
   hide the other two. Default: Masonry (set via .is-active in HTML).
   ════════════════════════════════════════════════════════════════ */
(function efOfMeasureTabsInit() {
  function init() {
    var tabs = document.querySelectorAll('.ef-of__measure-tab');
    if (!tabs.length) return;
    var panels = document.querySelectorAll('.ef-of__measure-panel');
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.mtab;
        tabs.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (p.dataset.mpanel === key) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ════════════════════════════════════════════════════════════════
   CARD ZOOM MODAL — mobile tap-to-zoom on option cards (orderform).
   Mirrors ef-configurator-v2.js efCfgZoomModalInit (lines 4392-4476).
   Uses event delegation so cards rendered later (e.g. mesh re-render
   on door_type change) work without re-binding.
   ════════════════════════════════════════════════════════════════ */
(function efOfZoomModalInit() {
  function init() {
    var modal = document.getElementById('efOfZoom');
    if (!modal) return;
    var img       = document.getElementById('efOfZoomImg');
    var titleEl   = document.getElementById('efOfZoomTitle');
    var descEl    = document.getElementById('efOfZoomDesc');
    var priceEl   = document.getElementById('efOfZoomPrice');
    var chooseBtn = document.getElementById('efOfZoomChoose');
    var sourceCard = null;
    var lastFocus = null;

    function open(card) {
      if (!card) return;
      sourceCard = card;
      lastFocus = document.activeElement;
      var imgSrc = (card.querySelector('.ef-cfg-card__img img') || {}).src || '';
      var title  = (card.querySelector('.ef-cfg-card__title') || {}).textContent || '';
      var desc   = (card.querySelector('.ef-cfg-card__desc')  || {}).textContent || '';
      var price  = (card.querySelector('.ef-cfg-card__price') || {}).textContent || '';
      img.src = imgSrc;
      img.alt = title;
      titleEl.textContent = title;
      descEl.textContent  = desc;
      priceEl.textContent = price;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { chooseBtn && chooseBtn.focus(); }, 60);
    }
    function close() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      sourceCard = null;
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    }

    /* Open via delegation — works for re-rendered cards (mesh swap) */
    document.addEventListener('click', function (e) {
      var z = e.target.closest && e.target.closest('[data-cfg-zoom]');
      if (!z) return;
      /* Only handle cards inside the orderform — avoids double-firing
         if cfg v2 also has a zoom modal mounted on the same page. */
      var card = z.closest('.ef-of__cd-opt');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      open(card);
    });
    /* Keyboard: Enter/Space on the span[role=button] */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var z = e.target.closest && e.target.closest('[data-cfg-zoom]');
      if (!z) return;
      var card = z.closest('.ef-of__cd-opt');
      if (!card) return;
      e.preventDefault();
      open(card);
    });

    /* Close handlers — backdrop, X button, or Escape key */
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-zoom-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
    });

    /* "Choose this" — synthesize a click on the source card so the
       existing onOptClick handler runs (sets selection, updates total,
       closes details). Then close the modal. */
    chooseBtn && chooseBtn.addEventListener('click', function () {
      if (sourceCard) { try { sourceCard.click(); } catch (e) {} }
      close();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
